export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Accepts URL or file uploads according to graphql-multipart-request-spec */
  AbsoluteUpload: any;
  /** Date (isoformat) */
  Date: any;
  /** Date with time (isoformat) */
  DateTime: any;
  Email: any;
  /** Event Slug or Event ID */
  EventID: any;
  InviteIdList: any;
  /** Must be lowercase, no special characters or whitespace */
  SlugField: any;
};


export type AddGroupSessionAttendee = {
  groupSessionId: Scalars['ID'];
  email: Scalars['Email'];
};

export type AddMeetingUser = {
  meetingId: Scalars['ID'];
  email: Scalars['Email'];
  role: RoleChoices;
};

export type AddOrganizationAdmin = {
  email: Scalars['Email'];
  organizationId: Scalars['ID'];
};

export type AddTagToInvite = {
  eventId: Scalars['EventID'];
  email: Scalars['Email'];
  tags: Array<Scalars['String']>;
};

export type AddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
};

export type AddressType = {
  addressLine1: Scalars['String'];
  addressLine2: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
};

export type AdminFilter = {
  firstName?: Maybe<StrFilterLookup>;
  lastName?: Maybe<StrFilterLookup>;
  email?: Maybe<Scalars['Email']>;
};

export type BoothCategoryType = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BoothDocumentType = {
  id: Scalars['Int'];
  booth: BoothType;
  order: Scalars['Int'];
  name: Scalars['String'];
  file: Scalars['AbsoluteUpload'];
};

export type BoothSpaceConnection = {
  edges: Array<Maybe<BoothSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type BoothSpaceEdge = {
  cursor: Scalars['Int'];
  node: BoothType;
};

export type BoothSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type BoothType = {
  maxStaff: Scalars['Int'];
  maxVideos: Scalars['Int'];
  maxDocuments: Scalars['Int'];
  maxJobOpenings: Scalars['Int'];
  enableChat: Scalars['Boolean'];
  enableVideocall: Scalars['Boolean'];
  enableSpecialOffers: Scalars['Boolean'];
  enableRequestSample: Scalars['Boolean'];
  enableAppointments: Scalars['Boolean'];
  enableVisitorList: Scalars['Boolean'];
  order: Scalars['Int'];
  color: Scalars['String'];
  image?: Maybe<Scalars['AbsoluteUpload']>;
  companyLogo?: Maybe<Scalars['AbsoluteUpload']>;
  boothLogo?: Maybe<Scalars['AbsoluteUpload']>;
  contactEmail?: Maybe<Scalars['Email']>;
  website?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type: BoothTypeOption;
  id: Scalars['Int'];
  parent: SpaceType;
  staffMembers: Array<UserType>;
  videos?: Maybe<Array<BoothVideoType>>;
  documents?: Maybe<Array<BoothDocumentType>>;
  physicalLocation?: Maybe<EventMapItemType>;
  categories: Array<BoothCategoryType>;
};

export enum BoothTypeOption {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}

export type BoothVideoType = {
  id: Scalars['Int'];
  booth: BoothType;
  order: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['AbsoluteUpload']>;
  embeddedUrl?: Maybe<Scalars['String']>;
};

export type BulkUploadError = {
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  hiddenMessage?: Maybe<Scalars['String']>;
};

export type CinemaConnection = {
  edges: Array<Maybe<CinemaEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type CinemaEdge = {
  cursor: Scalars['Int'];
  node: CinemaType;
};

export type CinemaSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type CinemaType = {
  id: Scalars['Int'];
  parent: SpaceType;
  movies?: Maybe<MovieConnection>;
};


export type CinemaTypeMoviesArgs = {
  search?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CreateBooth = {
  maxStaff?: Maybe<Scalars['Int']>;
  maxVideos?: Maybe<Scalars['Int']>;
  maxDocuments?: Maybe<Scalars['Int']>;
  maxJobOpenings?: Maybe<Scalars['Int']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  enableVideocall?: Maybe<Scalars['Boolean']>;
  enableSpecialOffers?: Maybe<Scalars['Boolean']>;
  enableRequestSample?: Maybe<Scalars['Boolean']>;
  enableAppointments?: Maybe<Scalars['Boolean']>;
  enableVisitorList?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  companyLogo?: Maybe<Scalars['AbsoluteUpload']>;
  boothLogo?: Maybe<Scalars['AbsoluteUpload']>;
  contactEmail?: Maybe<Scalars['Email']>;
  website?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<BoothTypeOption>;
  parent: CreateBoothParent;
  inviteStaff: Scalars['Email'];
  physicalLocationId?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Scalars['Int']>>;
};

export type CreateBoothParent = {
  name: Scalars['String'];
};

export type CreateEvent = {
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
};

export type CreateGroupSession = {
  id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  eventId: Scalars['EventID'];
  title: Scalars['String'];
};

export type CreateImage = {
  file: Scalars['AbsoluteUpload'];
  organizationId: Scalars['ID'];
};

export type CreateInvite = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['Email']>;
  jobtitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  googlePlus?: Maybe<Scalars['String']>;
  locationType?: Maybe<LocationType>;
  eventId: Scalars['EventID'];
  tags?: Maybe<Array<Scalars['Int']>>;
};

export type CreateMapItem = {
  name?: Maybe<Scalars['String']>;
  shape: Scalars['String'];
  embeddedUrl?: Maybe<Scalars['String']>;
  widget?: Maybe<WidgetType>;
  widgetLink?: Maybe<Scalars['String']>;
  forMobile?: Maybe<Scalars['Boolean']>;
  coords?: Maybe<Array<Scalars['Int']>>;
  mapId: Scalars['ID'];
  spaceId?: Maybe<Scalars['ID']>;
  refItemId?: Maybe<Scalars['ID']>;
};

export type CreateMeeting = {
  title: Scalars['String'];
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['Boolean']>;
  capacity?: Maybe<Scalars['Int']>;
  enableBreakoutRooms?: Maybe<Scalars['Boolean']>;
  isWalkInMeeting?: Maybe<Scalars['Boolean']>;
  spaceId: Scalars['ID'];
  programItemId?: Maybe<Scalars['ID']>;
};

export type CreateMovie = {
  title: Scalars['String'];
  subtitle: Scalars['String'];
  embeddedUrl: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  imageThumbnail?: Maybe<Scalars['AbsoluteUpload']>;
  cinemaId: Scalars['ID'];
  tags?: Maybe<Array<Scalars['Int']>>;
};

export type CreateMovieTagCategory = {
  text: Scalars['String'];
  eventSlug: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};

export type CreateNavigationItem = {
  id?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  submenuId?: Maybe<Scalars['ID']>;
  spaceId: Scalars['ID'];
  eventId: Scalars['EventID'];
  linkedSpaceId?: Maybe<Scalars['ID']>;
};

export type CreateNavigationMenu = {
  eventId: Scalars['EventID'];
  id?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};

export type CreateNavigationSubMenu = {
  id?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  menuId: Scalars['ID'];
};

export type CreatePerformer = {
  name: Scalars['String'];
  jobtitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  mugshot?: Maybe<Scalars['AbsoluteUpload']>;
  about?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  attachmentName?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
};

export type CreatePosterInput = {
  title: Scalars['String'];
  abstract?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['AbsoluteUpload']>;
  pdf?: Maybe<Scalars['AbsoluteUpload']>;
  authorNames?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  locationType?: Maybe<LocationType>;
  published?: Maybe<Scalars['Boolean']>;
  authorEmail?: Maybe<Scalars['Email']>;
  spaceId: Scalars['ID'];
};

export type CreateShow = {
  event: Scalars['EventID'];
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  image?: Maybe<Scalars['AbsoluteUpload']>;
  virtualImage?: Maybe<Scalars['AbsoluteUpload']>;
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
  attachmentName?: Maybe<Scalars['String']>;
  moderatorEmail?: Maybe<Scalars['Email']>;
  streamUrl?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  streamIsContinues?: Maybe<Scalars['Boolean']>;
  showAttendees?: Maybe<Scalars['Boolean']>;
  virtualSpaceId?: Maybe<Scalars['Int']>;
  mapitemId?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  performerIds?: Maybe<Array<Scalars['Int']>>;
  tags?: Maybe<Array<Scalars['Int']>>;
  segments?: Maybe<Array<Scalars['Int']>>;
  sponsorId?: Maybe<Scalars['Int']>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
};

export type CreateShowContainer = {
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  sponsorId?: Maybe<Scalars['ID']>;
  virtualSpaceId?: Maybe<Scalars['ID']>;
  mapitemId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Scalars['ID']>>;
};

export type CreateSpace = {
  event: Scalars['EventID'];
  type: SpaceTypeEnum;
  name: Scalars['String'];
  timetableOrder?: Scalars['Int'];
  image?: Maybe<Scalars['AbsoluteUpload']>;
};

export type CreateTag = {
  text: Scalars['String'];
  eventSlug: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['ID']>;
};

export type CreateTagCategory = {
  text: Scalars['String'];
  eventSlug: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};



/** This input deletes the space by space ID + type, or by parent ID. Leave type empty to delete by parent ID */
export type DeleteSpace = {
  id: Scalars['ID'];
  type?: Maybe<SpaceTypeEnum>;
};


export type EmbeddedSpaceConnection = {
  edges: Array<Maybe<EmbeddedSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type EmbeddedSpaceEdge = {
  cursor: Scalars['Int'];
  node: EmbeddedSpaceType;
};

export type EmbeddedSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type EmbeddedSpaceType = {
  id: Scalars['Int'];
  parent: SpaceType;
  url: Scalars['String'];
};

export type EventConnection = {
  edges: Array<Maybe<EventEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type EventEdge = {
  cursor: Scalars['Int'];
  node: EventType;
};


export type EventImageInput = {
  eventSlug: Scalars['String'];
  file: Scalars['AbsoluteUpload'];
};

export type EventImageType = {
  id: Scalars['Int'];
  file: Scalars['AbsoluteUpload'];
};

export type EventInviteConnection = {
  edges: Array<Maybe<EventInviteEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type EventInviteEdge = {
  cursor: Scalars['Int'];
  node: InviteType;
};

export type EventInviteFilter = {
  id?: Maybe<Scalars['Int']>;
};

export enum EventLanguage {
  Dutch = 'Dutch',
  English = 'English',
  German = 'German'
}

export type EventMapItemType = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EventMapType = {
  id: Scalars['Int'];
  name: Scalars['String'];
  mapType: Scalars['String'];
  mapitems?: Maybe<Array<EventMapItemType>>;
};

export type EventResellerConfigInput = {
  maxSpaces?: Maybe<Scalars['Int']>;
  maxBooths?: Maybe<Scalars['Int']>;
  maxParticipants?: Maybe<Scalars['Int']>;
  maxDurationInDays?: Maybe<Scalars['Int']>;
  maxDaysWithNetworking?: Maybe<Scalars['Int']>;
  enableChatCarousel?: Maybe<Scalars['Boolean']>;
};

export type EventType = {
  id: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  description: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  timezone: Scalars['String'];
  primaryBrandColor: Scalars['String'];
  secondaryBrandColor: Scalars['String'];
  terms?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  privacyStatement?: Maybe<Scalars['String']>;
  maxOwners: Scalars['Int'];
  organization?: Maybe<OrganizationType>;
  inviteOnly: Scalars['Boolean'];
  inviteMailSenderName: Scalars['String'];
  inviteMailReplyTo: Scalars['String'];
  inviteMailSubject: Scalars['String'];
  inviteMailNameFormat?: Maybe<Scalars['String']>;
  inviteMailSalutation?: Maybe<Scalars['String']>;
  timeFormat: Scalars['String'];
  language?: Maybe<EventLanguage>;
  spaces?: Maybe<SpaceConnection>;
  boothCategories?: Maybe<Array<BoothCategoryType>>;
  performers?: Maybe<PerformerConnection>;
  invites?: Maybe<EventInviteConnection>;
  userTags?: Maybe<Array<TagType>>;
  programTags?: Maybe<Array<TagType>>;
  movieTags?: Maybe<Array<TagType>>;
  maps: Array<EventMapType>;
  programTagCategories?: Maybe<Array<TagCategoryType>>;
  attendeeTagCategories?: Maybe<Array<TagCategoryType>>;
  movieTagCategories?: Maybe<Array<TagCategoryType>>;
  admins: UserConnection;
  amountOfParticipants?: Maybe<Scalars['Int']>;
  autostartVideo?: Maybe<Scalars['Boolean']>;
  backgroundImage?: Maybe<Scalars['AbsoluteUpload']>;
  booths: BoothSpaceConnection;
  cinemas: CinemaConnection;
  currentUserHasResellerAccess?: Maybe<Scalars['Boolean']>;
  embeddedSpaces: EmbeddedSpaceConnection;
  enableChatCarousel?: Maybe<Scalars['Boolean']>;
  enableGroupSessions?: Maybe<Scalars['Boolean']>;
  enablePageTranslation?: Maybe<Scalars['Boolean']>;
  goodiebagName?: Maybe<Scalars['String']>;
  groupSessions: GroupSessionConnection;
  hasPublishedNetworking?: Maybe<Scalars['Boolean']>;
  helpContent?: Maybe<Scalars['String']>;
  helpContentType?: Maybe<Scalars['String']>;
  homeSpace?: Maybe<SpaceType>;
  introVideo?: Maybe<Scalars['String']>;
  inviteMailIntro: Scalars['String'];
  inviteMailOutro: Scalars['String'];
  isActivationRequested: Scalars['Boolean'];
  loginFormAddendum?: Maybe<Scalars['String']>;
  mapSpaces: MapSpaceConnection;
  maxBooths?: Maybe<Scalars['Int']>;
  maxDaysWithNetworking?: Maybe<Scalars['Int']>;
  maxDurationInDays?: Maybe<Scalars['Int']>;
  maxParticipants?: Maybe<Scalars['Int']>;
  maxSpaces?: Maybe<Scalars['Int']>;
  meetingSpaces: MeetingSpaceConnection;
  navigationItems: Array<NavigationItemType>;
  navigationMenus: Array<NavigationMenuType>;
  networkingDaysLeft?: Maybe<Scalars['Int']>;
  networkingSpaces: NetworkingSpaceConnection;
  openedDaysLeft?: Maybe<Scalars['Int']>;
  paid?: Maybe<Scalars['Boolean']>;
  posterSpaces: PosterSpaceConnection;
  presentationSpaces: PresentationSpaceConnection;
  showBoothSidebar?: Maybe<Scalars['Boolean']>;
  showCalendarIcon?: Maybe<Scalars['Boolean']>;
  showSpeakerIcon?: Maybe<Scalars['Boolean']>;
  shows: ShowItemConnection;
  startWithLoginTab?: Maybe<Scalars['Boolean']>;
  textEventPreview?: Maybe<Scalars['String']>;
  userDataIsDeleted?: Maybe<Scalars['Boolean']>;
  virtualEventLogo?: Maybe<Scalars['AbsoluteUpload']>;
};


export type EventTypeSpacesArgs = {
  type?: Maybe<SpaceTypeEnum>;
  search?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypePerformersArgs = {
  filters?: Maybe<PerformerFilter>;
  orderBy?: Maybe<PerformerOrder>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeInvitesArgs = {
  filters?: Maybe<EventInviteFilter>;
  search?: Maybe<Scalars['String']>;
  status?: Maybe<InviteStatus>;
  orderBy?: Maybe<InviteOrder>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeAdminsArgs = {
  filters?: Maybe<AdminFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeBoothsArgs = {
  search?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<Array<Scalars['ID']>>;
  filters?: Maybe<BoothSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeCinemasArgs = {
  filters?: Maybe<CinemaSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeEmbeddedSpacesArgs = {
  filters?: Maybe<EmbeddedSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeGroupSessionsArgs = {
  filters?: Maybe<GroupSessionFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeMapSpacesArgs = {
  filters?: Maybe<MapSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeMeetingSpacesArgs = {
  filters?: Maybe<MeetingSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeNetworkingSpacesArgs = {
  filters?: Maybe<NetworkingSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypePosterSpacesArgs = {
  filters?: Maybe<PosterSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypePresentationSpacesArgs = {
  filters?: Maybe<PresentationSpaceFilter>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type EventTypeShowsArgs = {
  search?: Maybe<Scalars['String']>;
  upcomingOnly?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<ShowOrder>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
};

export type GroupSessionConnection = {
  edges: Array<Maybe<GroupSessionEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type GroupSessionEdge = {
  cursor: Scalars['Int'];
  node: GroupSessionType;
};

export type GroupSessionFilter = {
  id?: Maybe<Scalars['Int']>;
};

export type GroupSessionType = {
  id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  participants: UserConnection;
  title: Scalars['String'];
};


export type GroupSessionTypeParticipantsArgs = {
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ImageConnection = {
  edges: Array<Maybe<ImageEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type ImageEdge = {
  cursor: Scalars['Int'];
  node: ImageType;
};

export type ImageType = {
  id: Scalars['Int'];
  file: Scalars['AbsoluteUpload'];
};

export type ImportInvite = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['Email']>;
  jobtitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  googlePlus?: Maybe<Scalars['String']>;
  locationType?: Maybe<LocationType>;
  programExternalIds?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type ImportMeeting = {
  title: Scalars['String'];
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['Boolean']>;
  capacity?: Maybe<Scalars['Int']>;
  enableBreakoutRooms?: Maybe<Scalars['Boolean']>;
  isWalkInMeeting?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type ImportMeetingParticipant = {
  externalId: Scalars['ID'];
  email: Scalars['Email'];
  role: RoleChoices;
  delete?: Maybe<Scalars['Boolean']>;
};

export type ImportMovie = {
  title: Scalars['String'];
  subtitle: Scalars['String'];
  embeddedUrl: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  imageThumbnail?: Maybe<Scalars['AbsoluteUpload']>;
  externalId?: Maybe<Scalars['String']>;
  delete?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type ImportPerformer = {
  name?: Maybe<Scalars['String']>;
  jobtitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  mugshot?: Maybe<Scalars['AbsoluteUpload']>;
  about?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  attachmentName?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
  externalId?: Maybe<Scalars['String']>;
  delete?: Maybe<Scalars['Boolean']>;
  sessions?: Maybe<Array<Scalars['String']>>;
};

export type ImportPoster = {
  title: Scalars['String'];
  abstract?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['AbsoluteUpload']>;
  pdf?: Maybe<Scalars['AbsoluteUpload']>;
  authorNames?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  locationType?: Maybe<LocationType>;
  externalId?: Maybe<Scalars['String']>;
  authorEmail?: Maybe<Scalars['Email']>;
  published?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type ImportResult = {
  successCount: Scalars['Int'];
  errorCount: Scalars['Int'];
  errorItems: Array<BulkUploadError>;
};

export type ImportShow = {
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  virtualImage?: Maybe<Scalars['AbsoluteUpload']>;
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
  attachmentName?: Maybe<Scalars['String']>;
  moderatorEmail?: Maybe<Scalars['Email']>;
  streamUrl?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  streamIsContinues?: Maybe<Scalars['Boolean']>;
  showAttendees?: Maybe<Scalars['Boolean']>;
  virtualSpace?: Maybe<Scalars['String']>;
  mapItem?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  performerExternalIds?: Maybe<Array<Scalars['String']>>;
  isParent?: Maybe<Scalars['Boolean']>;
  onlyForSegments?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  delete?: Maybe<Scalars['Boolean']>;
  sponsor?: Maybe<Scalars['String']>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
};

export type InviteAdmin = {
  event: Scalars['EventID'];
  email: Scalars['Email'];
};


export enum InviteOrder {
  CreatedAsc = 'createdAsc',
  CreatedDesc = 'createdDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  EmailAsc = 'emailAsc',
  EmailDesc = 'emailDesc',
  MailSentAsc = 'mailSentAsc',
  MailSentDesc = 'mailSentDesc'
}

export type InviteSegmentsInput = {
  eventId: Scalars['EventID'];
  email: Scalars['Email'];
  segments: Array<Scalars['String']>;
  shouldOverwrite?: Maybe<Scalars['Boolean']>;
};

export enum InviteStatus {
  New = 'new',
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined'
}

export enum InviteTo {
  All = 'all',
  Pending = 'pending',
  New = 'new'
}

export type InviteType = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['Email'];
  jobtitle: Scalars['String'];
  company: Scalars['String'];
  about: Scalars['String'];
  website: Scalars['String'];
  twitter: Scalars['String'];
  facebook: Scalars['String'];
  linkedin: Scalars['String'];
  instagram: Scalars['String'];
  googlePlus: Scalars['String'];
  locationType?: Maybe<LocationType>;
  id: Scalars['Int'];
  created: Scalars['DateTime'];
  mailSent?: Maybe<Scalars['DateTime']>;
  tags: Array<TagType>;
  isStaff: Scalars['Boolean'];
  status: InviteStatus;
};

export enum LocationType {
  Virtual = 'VIRTUAL',
  InPerson = 'IN_PERSON',
  Hybrid = 'HYBRID'
}

export type MapItemType = {
  name: Scalars['String'];
  shape: Scalars['String'];
  embeddedUrl?: Maybe<Scalars['String']>;
  widget?: Maybe<WidgetType>;
  widgetLink?: Maybe<Scalars['String']>;
  forMobile: Scalars['Boolean'];
  id: Scalars['Int'];
  map: MapSpaceType;
  space?: Maybe<SpaceType>;
  coords: Array<Scalars['Int']>;
};

export type MapSpaceConnection = {
  edges: Array<Maybe<MapSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type MapSpaceEdge = {
  cursor: Scalars['Int'];
  node: MapSpaceType;
};

export type MapSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type MapSpaceType = {
  id: Scalars['Int'];
  parent: SpaceType;
  backgroundColor: Scalars['String'];
  items?: Maybe<Array<MapItemType>>;
};

export type MeetingConnection = {
  edges: Array<Maybe<MeetingEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type MeetingEdge = {
  cursor: Scalars['Int'];
  node: MeetingType;
};

export type MeetingFilter = {
  id?: Maybe<Scalars['Int']>;
  closed?: Maybe<Scalars['Boolean']>;
};

export enum MeetingOrder {
  TitleAsc = 'titleAsc',
  TitleDesc = 'titleDesc',
  StartsAtAsc = 'startsAtAsc',
  StartsAtDesc = 'startsAtDesc',
  TotalCapacityAsc = 'totalCapacityAsc',
  TotalCapacityDesc = 'totalCapacityDesc',
  CapacityLeftAsc = 'capacityLeftAsc',
  CapacityLeftDesc = 'capacityLeftDesc'
}

export type MeetingSpaceConnection = {
  edges: Array<Maybe<MeetingSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type MeetingSpaceEdge = {
  cursor: Scalars['Int'];
  node: MeetingSpaceType;
};

export type MeetingSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type MeetingSpaceType = {
  id: Scalars['Int'];
  parent: SpaceType;
  meetings: MeetingConnection;
};


export type MeetingSpaceTypeMeetingsArgs = {
  filters?: Maybe<MeetingFilter>;
  search?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  orderBy?: Maybe<MeetingOrder>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type MeetingType = {
  title: Scalars['String'];
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  description: Scalars['String'];
  closed: Scalars['Boolean'];
  capacity: Scalars['Int'];
  enableBreakoutRooms: Scalars['Boolean'];
  isWalkInMeeting: Scalars['Boolean'];
  id: Scalars['Int'];
  space: SpaceType;
  programItem?: Maybe<ShowType>;
  capacityLeft?: Maybe<Scalars['Int']>;
  participants: MeetingUserConnection;
  hosts: MeetingUserConnection;
};


export type MeetingTypeParticipantsArgs = {
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MeetingTypeHostsArgs = {
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type MeetingUserConnection = {
  edges: Array<Maybe<MeetingUserEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type MeetingUserEdge = {
  cursor: Scalars['Int'];
  node: MeetingUserType;
};

export type MeetingUserType = {
  id: Scalars['Int'];
  role: Scalars['String'];
  user: UserType;
};

export type MovieConnection = {
  edges: Array<Maybe<MovieEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type MovieEdge = {
  cursor: Scalars['Int'];
  node: MovieType;
};

export type MovieType = {
  title: Scalars['String'];
  subtitle: Scalars['String'];
  embeddedUrl: Scalars['String'];
  order: Scalars['Int'];
  published: Scalars['Boolean'];
  imageThumbnail?: Maybe<Scalars['AbsoluteUpload']>;
  id: Scalars['Int'];
  cinema: CinemaType;
  tags?: Maybe<Array<TagType>>;
};

export type Mutation = {
  /** For usage of GraphiQL only, for app we use JWT */
  login: Scalars['Boolean'];
  inviteAdmin: Scalars['Boolean'];
  removeAdmin: Scalars['Boolean'];
  createEvent: EventType;
  updateEvent: EventType;
  requestEventActivation: EventType;
  updatePerformer: PerformerType;
  createPerformer: PerformerType;
  deletePerformer: Scalars['Boolean'];
  createInvite: InviteType;
  updateInvite: InviteType;
  deleteInvite: Scalars['Boolean'];
  /** Send invites, http response waits for all invites to be send before returning response. */
  sendBatchInviteEmails: Array<InviteType>;
  /** Queue invites without having to wait for all invites to be send. Progress will be send to the user if a authenticated websocket connection is opened. */
  queueInviteEmails: Scalars['Boolean'];
  /** Queue invites without having to wait for all invites to be send. Progress will be send to the user if a authenticated websocket connection is opened. */
  queueBatchInviteEmails: Scalars['Boolean'];
  /** Send invites, http response waits for all invites to be send before returning response. */
  sendInviteEmails: Array<InviteType>;
  sendTestEmailToCurrentUser: Scalars['Boolean'];
  setIsStaff: Scalars['Boolean'];
  createImage: ImageType;
  deleteImage: Scalars['Boolean'];
  updateOrganization: OrganizationType;
  addOrganizationAdmin: UserType;
  removeOrganizationAdmin: UserType;
  createSpace: SpaceType;
  deleteSpace: Scalars['Boolean'];
  updateSpace: SpaceType;
  createEventImage: EventImageType;
  createAttendeeTagCategory: TagCategoryType;
  updateAttendeeTagCategory: TagCategoryType;
  deleteAttendeeTagCategory: Scalars['Boolean'];
  createAttendeeTag: TagType;
  updateAttendeeTag: TagType;
  deleteAttendeeTag: Scalars['Boolean'];
  createProgramTagCategory: TagCategoryType;
  updateProgramTagCategory: TagCategoryType;
  deleteProgramTagCategory: Scalars['Boolean'];
  createProgramTag: TagType;
  updateProgramTag: TagType;
  deleteProgramTag: Scalars['Boolean'];
  updateBooth: BoothType;
  createBooth: BoothType;
  createMovie: MovieType;
  updateMovie: MovieType;
  deleteMovie: Scalars['Boolean'];
  updateCinema: CinemaType;
  importMovie: ImportResult;
  createMovieTagCategory: TagCategoryType;
  updateMovieTagCategory: TagCategoryType;
  deleteMovieTagCategory: Scalars['Boolean'];
  createMovieTag: TagType;
  updateMovieTag: TagType;
  deleteMovieTag: Scalars['Boolean'];
  createShow: ShowType;
  updateShows: Array<ShowType>;
  deleteShows: Scalars['Boolean'];
  importShows: ImportResult;
  createShowContainer: ShowContainerType;
  updateShowContainer: ShowContainerType;
  deleteShowContainer: Scalars['Boolean'];
  createNavigationItem: NavigationItemType;
  updateNavigationItem: NavigationItemType;
  deleteNavigationItem: Scalars['Boolean'];
  createNavigationMenu: NavigationMenuType;
  updateNavigationMenu: NavigationItemType;
  deleteNavigationMenu: Scalars['Boolean'];
  createNavigationSubMenu: NavigationSubMenuType;
  updateNavigationSubMenu: NavigationSubMenuType;
  deleteNavigationSubMenu: Scalars['Boolean'];
  updatePresentationSpace: PresentationSpaceType;
  updateNetworkingSpace: NetworkingSpaceType;
  createMapItem: MapItemType;
  updateMapItem: MapItemType;
  deleteMapItem: Scalars['Boolean'];
  updateMapSpace: MapSpaceType;
  createPoster: PosterType;
  updatePoster: PosterType;
  deletePoster: Scalars['Boolean'];
  updatePosterSpace: PosterSpaceType;
  importPoster: ImportResult;
  updateMeetingSpace: MeetingSpaceType;
  updateMeeting: MeetingType;
  createMeeting: MeetingType;
  deleteMeeting: Scalars['Boolean'];
  addMeetingUser: MeetingUserType;
  updateMeetingUser: MeetingUserType;
  removeMeetingUser: Scalars['Boolean'];
  importMeeting: ImportResult;
  importMeetingParticipants: ImportResult;
  createGroupSession: GroupSessionType;
  updateGroupSession: GroupSessionType;
  deleteGroupSession: Scalars['Boolean'];
  addGroupSessionAttendee: UserType;
  removeGroupSessionAttendee: Scalars['Boolean'];
  addTagToInvite: Scalars['Boolean'];
  addSegmentToInvite: Scalars['Boolean'];
  importInvites: ImportResult;
  importPerformers: ImportResult;
  removeUserDataFromEvent: Scalars['Boolean'];
  updateEmbeddedSpace: EmbeddedSpaceType;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationInviteAdminArgs = {
  data: InviteAdmin;
};


export type MutationRemoveAdminArgs = {
  data: RemoveAdmin;
};


export type MutationCreateEventArgs = {
  data: CreateEvent;
};


export type MutationUpdateEventArgs = {
  event: Scalars['EventID'];
  data: UpdateEventInput;
};


export type MutationRequestEventActivationArgs = {
  eventId: Scalars['EventID'];
};


export type MutationUpdatePerformerArgs = {
  id: Scalars['Int'];
  data: UpdatePerformer;
};


export type MutationCreatePerformerArgs = {
  event: Scalars['EventID'];
  data: CreatePerformer;
};


export type MutationDeletePerformerArgs = {
  id: Scalars['Int'];
};


export type MutationCreateInviteArgs = {
  data: CreateInvite;
};


export type MutationUpdateInviteArgs = {
  id: Scalars['ID'];
  data: UpdateInvite;
};


export type MutationDeleteInviteArgs = {
  id: Scalars['ID'];
};


export type MutationSendBatchInviteEmailsArgs = {
  data: SendBatchInviteEmails;
};


export type MutationQueueInviteEmailsArgs = {
  data: QueueInviteEmails;
};


export type MutationQueueBatchInviteEmailsArgs = {
  data: QueueBatchInviteEmails;
};


export type MutationSendInviteEmailsArgs = {
  data: SendInviteEmails;
};


export type MutationSendTestEmailToCurrentUserArgs = {
  eventId: Scalars['EventID'];
};


export type MutationSetIsStaffArgs = {
  data: SetIsStaff;
};


export type MutationCreateImageArgs = {
  data: CreateImage;
};


export type MutationDeleteImageArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID'];
  data: UpdateOrganization;
};


export type MutationAddOrganizationAdminArgs = {
  data: AddOrganizationAdmin;
};


export type MutationRemoveOrganizationAdminArgs = {
  data: RemoveOrganizationAdmin;
};


export type MutationCreateSpaceArgs = {
  data: CreateSpace;
};


export type MutationDeleteSpaceArgs = {
  data: DeleteSpace;
};


export type MutationUpdateSpaceArgs = {
  id: Scalars['ID'];
  data: UpdateSpace;
};


export type MutationCreateEventImageArgs = {
  data: EventImageInput;
};


export type MutationCreateAttendeeTagCategoryArgs = {
  data: CreateTagCategory;
};


export type MutationUpdateAttendeeTagCategoryArgs = {
  id: Scalars['ID'];
  data: UpdateTagCategory;
};


export type MutationDeleteAttendeeTagCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAttendeeTagArgs = {
  data: CreateTag;
};


export type MutationUpdateAttendeeTagArgs = {
  id: Scalars['ID'];
  data: UpdateTag;
};


export type MutationDeleteAttendeeTagArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProgramTagCategoryArgs = {
  data: CreateTagCategory;
};


export type MutationUpdateProgramTagCategoryArgs = {
  id: Scalars['ID'];
  data: UpdateTagCategory;
};


export type MutationDeleteProgramTagCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProgramTagArgs = {
  data: CreateTag;
};


export type MutationUpdateProgramTagArgs = {
  id: Scalars['ID'];
  data: UpdateTag;
};


export type MutationDeleteProgramTagArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateBoothArgs = {
  id: Scalars['Int'];
  data: UpdateBooth;
};


export type MutationCreateBoothArgs = {
  event: Scalars['EventID'];
  data: CreateBooth;
};


export type MutationCreateMovieArgs = {
  data: CreateMovie;
};


export type MutationUpdateMovieArgs = {
  id: Scalars['ID'];
  data: UpdateMovie;
};


export type MutationDeleteMovieArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateCinemaArgs = {
  id: Scalars['Int'];
  data: UpdateCinema;
};


export type MutationImportMovieArgs = {
  cinemaSpace: Scalars['ID'];
  data: Array<ImportMovie>;
};


export type MutationCreateMovieTagCategoryArgs = {
  data: CreateMovieTagCategory;
};


export type MutationUpdateMovieTagCategoryArgs = {
  id: Scalars['ID'];
  data: UpdateTagCategory;
};


export type MutationDeleteMovieTagCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationCreateMovieTagArgs = {
  data: CreateTag;
};


export type MutationUpdateMovieTagArgs = {
  id: Scalars['ID'];
  data: UpdateTag;
};


export type MutationDeleteMovieTagArgs = {
  id: Scalars['ID'];
};


export type MutationCreateShowArgs = {
  data: CreateShow;
};


export type MutationUpdateShowsArgs = {
  data: UpdateShow;
  filters?: Maybe<ShowFilter>;
};


export type MutationDeleteShowsArgs = {
  filters: ShowFilter;
};


export type MutationImportShowsArgs = {
  event: Scalars['EventID'];
  data: Array<ImportShow>;
};


export type MutationCreateShowContainerArgs = {
  event: Scalars['EventID'];
  data: CreateShowContainer;
};


export type MutationUpdateShowContainerArgs = {
  id: Scalars['Int'];
  data: UpdateShowContainer;
};


export type MutationDeleteShowContainerArgs = {
  id: Scalars['Int'];
};


export type MutationCreateNavigationItemArgs = {
  data: CreateNavigationItem;
};


export type MutationUpdateNavigationItemArgs = {
  id: Scalars['ID'];
  data: UpdateNavigationItem;
};


export type MutationDeleteNavigationItemArgs = {
  id: Scalars['ID'];
};


export type MutationCreateNavigationMenuArgs = {
  data: CreateNavigationMenu;
};


export type MutationUpdateNavigationMenuArgs = {
  id: Scalars['ID'];
  data: UpdateNavigationMenu;
};


export type MutationDeleteNavigationMenuArgs = {
  id: Scalars['ID'];
};


export type MutationCreateNavigationSubMenuArgs = {
  data: CreateNavigationSubMenu;
};


export type MutationUpdateNavigationSubMenuArgs = {
  id: Scalars['ID'];
  data: UpdateNavigationSubMenu;
};


export type MutationDeleteNavigationSubMenuArgs = {
  id: Scalars['ID'];
};


export type MutationUpdatePresentationSpaceArgs = {
  id: Scalars['Int'];
  data: UpdatePresentationSpaceInput;
};


export type MutationUpdateNetworkingSpaceArgs = {
  id: Scalars['ID'];
  data: UpdateNetworkingSpaceInput;
};


export type MutationCreateMapItemArgs = {
  data: CreateMapItem;
};


export type MutationUpdateMapItemArgs = {
  id: Scalars['ID'];
  data: UpdateMapItem;
};


export type MutationDeleteMapItemArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateMapSpaceArgs = {
  id: Scalars['ID'];
  data: UpdateMapSpaceInput;
};


export type MutationCreatePosterArgs = {
  data: CreatePosterInput;
};


export type MutationUpdatePosterArgs = {
  id: Scalars['ID'];
  data: UpdatePosterInput;
};


export type MutationDeletePosterArgs = {
  id: Scalars['ID'];
};


export type MutationUpdatePosterSpaceArgs = {
  posterSpace: Scalars['Int'];
  data: UpdatePosterSpaceInput;
};


export type MutationImportPosterArgs = {
  posterSpace: Scalars['ID'];
  data: Array<ImportPoster>;
};


export type MutationUpdateMeetingSpaceArgs = {
  id: Scalars['ID'];
  data: UpdateMeetingSpace;
};


export type MutationUpdateMeetingArgs = {
  id: Scalars['ID'];
  data: UpdateMeeting;
};


export type MutationCreateMeetingArgs = {
  data: CreateMeeting;
};


export type MutationDeleteMeetingArgs = {
  id: Scalars['ID'];
};


export type MutationAddMeetingUserArgs = {
  data: AddMeetingUser;
};


export type MutationUpdateMeetingUserArgs = {
  id: Scalars['ID'];
  data: UpdateMeetingUser;
};


export type MutationRemoveMeetingUserArgs = {
  id: Scalars['ID'];
};


export type MutationImportMeetingArgs = {
  meetingSpace: Scalars['ID'];
  data: Array<ImportMeeting>;
};


export type MutationImportMeetingParticipantsArgs = {
  meetingSpace: Scalars['ID'];
  data: Array<ImportMeetingParticipant>;
};


export type MutationCreateGroupSessionArgs = {
  data: CreateGroupSession;
};


export type MutationUpdateGroupSessionArgs = {
  id: Scalars['ID'];
  data: UpdateGroupSession;
};


export type MutationDeleteGroupSessionArgs = {
  id: Scalars['ID'];
};


export type MutationAddGroupSessionAttendeeArgs = {
  data: AddGroupSessionAttendee;
};


export type MutationRemoveGroupSessionAttendeeArgs = {
  data: RemoveGroupSessionAttendee;
};


export type MutationAddTagToInviteArgs = {
  data: AddTagToInvite;
};


export type MutationAddSegmentToInviteArgs = {
  data: InviteSegmentsInput;
};


export type MutationImportInvitesArgs = {
  event: Scalars['EventID'];
  data: Array<ImportInvite>;
};


export type MutationImportPerformersArgs = {
  event: Scalars['EventID'];
  data: Array<ImportPerformer>;
};


export type MutationRemoveUserDataFromEventArgs = {
  event: Scalars['EventID'];
};


export type MutationUpdateEmbeddedSpaceArgs = {
  embeddedSpace: Scalars['Int'];
  data: UpdateEmbeddedSpaceInput;
};

export type MyEventFilters = {
  id?: Maybe<Scalars['Int']>;
  organization?: Maybe<OrganizationFilters>;
};

export enum NameFormat {
  Full = 'full',
  First = 'first',
  Last = 'last'
}

export type NavigationItemType = {
  id: Scalars['Int'];
  text: Scalars['String'];
  order: Scalars['Int'];
  event: EventType;
  submenu?: Maybe<NavigationSubMenuType>;
  space: SpaceType;
  linkedSpace?: Maybe<SpaceType>;
};

export type NavigationMenuType = {
  id: Scalars['Int'];
  text: Scalars['String'];
  order: Scalars['Int'];
  event: EventType;
  subMenus?: Maybe<Array<NavigationSubMenuType>>;
};

export type NavigationSubMenuType = {
  id: Scalars['Int'];
  text: Scalars['String'];
  order: Scalars['Int'];
  menu: NavigationMenuType;
  items?: Maybe<Array<NavigationItemType>>;
};

export type NetworkingSpaceConnection = {
  edges: Array<Maybe<NetworkingSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type NetworkingSpaceEdge = {
  cursor: Scalars['Int'];
  node: NetworkingSpaceType;
};

export type NetworkingSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type NetworkingSpaceType = {
  id: Scalars['Int'];
  parent: SpaceType;
  callsCapacity: Scalars['Int'];
};

export type OrganizationConnection = {
  edges: Array<Maybe<OrganizationEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type OrganizationEdge = {
  cursor: Scalars['Int'];
  node: OrganizationType;
};

export type OrganizationFilters = {
  id?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['Int']>;
  subdomain?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['Email']>;
};

export enum OrganizationLanguage {
  Dutch = 'Dutch',
  English = 'English',
  German = 'German'
}

export type OrganizationType = {
  id: Scalars['Int'];
  externalId?: Maybe<Scalars['Int']>;
  subdomain?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  admins: Array<UserType>;
  contactName: Scalars['String'];
  contactPosition: Scalars['String'];
  contactEmail: Scalars['Email'];
  contactPhone: Scalars['String'];
  physicalAddress: AddressType;
  billingAddress: AddressType;
  membershipActivatedAt?: Maybe<Scalars['DateTime']>;
  cocNumber: Scalars['String'];
  vatNumber: Scalars['String'];
  billingDepartment: Scalars['String'];
  language?: Maybe<OrganizationLanguage>;
  images?: Maybe<ImageConnection>;
  billingAddressIsPhysicalAddress: Scalars['Boolean'];
  membershipExpiresAt?: Maybe<Scalars['DateTime']>;
  membershipIsActivated?: Maybe<Scalars['Boolean']>;
};


export type OrganizationTypeImagesArgs = {
  tag?: Maybe<SpaceTypeEnum>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Information about pagination in a connection, based on https://graphql.github.io/learn/pagination/ */
export type Pagination = {
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating forwards, the cursor to continue */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating backwards, the cursor to continue */
  endCursor?: Maybe<Scalars['String']>;
};

export type PerformerConnection = {
  edges: Array<Maybe<PerformerEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type PerformerEdge = {
  cursor: Scalars['Int'];
  node: PerformerType;
};

export type PerformerFilter = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<StrFilterLookup>;
};

export enum PerformerOrder {
  Id = 'id',
  TitleAsc = 'titleAsc',
  TitleDesc = 'titleDesc'
}

export type PerformerType = {
  name: Scalars['String'];
  jobtitle: Scalars['String'];
  company: Scalars['String'];
  mugshot: Scalars['AbsoluteUpload'];
  about?: Maybe<Scalars['String']>;
  website: Scalars['String'];
  instagram: Scalars['String'];
  twitter: Scalars['String'];
  facebook: Scalars['String'];
  linkedin: Scalars['String'];
  youtube: Scalars['String'];
  attachmentName: Scalars['String'];
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
  id: Scalars['Int'];
  locationType: Scalars['String'];
};

export type PosterConnection = {
  edges: Array<Maybe<PosterEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type PosterEdge = {
  cursor: Scalars['Int'];
  node: PosterType;
};

export enum PosterOrder {
  AuthorNamesAsc = 'authorNamesAsc',
  AuthorNamesDesc = 'authorNamesDesc',
  TitleAsc = 'titleAsc',
  TitleDesc = 'titleDesc'
}

export enum PosterSorting {
  Author = 'author',
  Title = 'title'
}

export type PosterSpaceConnection = {
  edges: Array<Maybe<PosterSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type PosterSpaceEdge = {
  cursor: Scalars['Int'];
  node: PosterSpaceType;
};

export type PosterSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type PosterSpaceType = {
  id: Scalars['Int'];
  parent: SpaceType;
  enableVideo: Scalars['Boolean'];
  enableMessaging: Scalars['Boolean'];
  posterSorting: Scalars['String'];
  posters?: Maybe<PosterConnection>;
};


export type PosterSpaceTypePostersArgs = {
  search?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<PosterOrder>;
};

export type PosterType = {
  title: Scalars['String'];
  abstract: Scalars['String'];
  preview?: Maybe<Scalars['AbsoluteUpload']>;
  pdf?: Maybe<Scalars['AbsoluteUpload']>;
  authorNames?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  enableChat: Scalars['Boolean'];
  locationType?: Maybe<LocationType>;
  id: Scalars['Int'];
  author?: Maybe<UserType>;
  space: PosterSpaceType;
};

export type PresentationSpaceConnection = {
  edges: Array<Maybe<PresentationSpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type PresentationSpaceEdge = {
  cursor: Scalars['Int'];
  node: PresentationSpaceType;
};

export type PresentationSpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<SpaceFilter>;
};

export type PresentationSpaceType = {
  id: Scalars['Int'];
  parent?: Maybe<SpaceType>;
  streamIsContinues: Scalars['Boolean'];
  streamUrl?: Maybe<Scalars['String']>;
  interactionIsContinues: Scalars['Boolean'];
  interactionUrl?: Maybe<Scalars['String']>;
  showAttendees: Scalars['Boolean'];
};

export type Query = {
  currentUser: UserType;
  event: EventType;
  myEvents: EventConnection;
  organization: OrganizationType;
  myOrganizations: OrganizationConnection;
  show: ShowType;
  showContainer: ShowContainerType;
  showContainers: Array<ShowContainerType>;
};


export type QueryEventArgs = {
  id: Scalars['EventID'];
};


export type QueryMyEventsArgs = {
  filters?: Maybe<MyEventFilters>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryMyOrganizationsArgs = {
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryShowArgs = {
  id: Scalars['Int'];
};


export type QueryShowContainerArgs = {
  id: Scalars['Int'];
};


export type QueryShowContainersArgs = {
  eventSlug: Scalars['String'];
};

export type QueueBatchInviteEmails = {
  eventId: Scalars['EventID'];
  to: InviteTo;
};

export type QueueInviteEmails = {
  eventId: Scalars['EventID'];
  to: Scalars['InviteIdList'];
};

export type RemoveAdmin = {
  event: Scalars['EventID'];
  id: Scalars['ID'];
};

export type RemoveGroupSessionAttendee = {
  groupSessionId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveOrganizationAdmin = {
  email: Scalars['Email'];
  organizationId: Scalars['ID'];
};

export enum RoleChoices {
  PrimarySpeaker = 'primary_speaker',
  Speaker = 'speaker',
  Moderator = 'moderator',
  Audience = 'audience'
}

export type SegmentType = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SendBatchInviteEmails = {
  eventId: Scalars['EventID'];
  to: InviteTo;
};

export type SendInviteEmails = {
  eventId: Scalars['EventID'];
  to: Scalars['InviteIdList'];
};

export type SetIsStaff = {
  userEmail: Scalars['Email'];
  eventId: Scalars['EventID'];
  isStaff: Scalars['Boolean'];
};

export type ShowContainerType = {
  id: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  image: Scalars['AbsoluteUpload'];
  virtualSpace?: Maybe<SpaceType>;
  mapitem?: Maybe<EventMapItemType>;
  tags?: Maybe<Array<TagType>>;
  onlyForSegments?: Maybe<Array<SegmentType>>;
  sponsor?: Maybe<SponsorType>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
};

export type ShowFilter = {
  id?: Maybe<Scalars['Int']>;
  virtualSpace?: Maybe<SpaceFilter>;
};

export type ShowItem = {
  id: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  sponsor?: Maybe<SponsorType>;
  playbackUrl?: Maybe<Scalars['String']>;
  virtualImage?: Maybe<Scalars['AbsoluteUpload']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  color?: Maybe<Scalars['String']>;
  mapitem?: Maybe<Scalars['String']>;
  virtualSpace?: Maybe<Scalars['String']>;
  isContainer?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<ShowItem>>;
};

export type ShowItemConnection = {
  edges: Array<Maybe<ShowItemEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type ShowItemEdge = {
  cursor: Scalars['Int'];
  node: ShowItem;
};

export enum ShowOrder {
  Id = 'id',
  DatetimeAsc = 'datetimeAsc',
  DatetimeDesc = 'datetimeDesc'
}

export type ShowType = {
  id: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
  parent?: Maybe<ShowType>;
  moderator?: Maybe<UserType>;
  streamUrl?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  enableChat: Scalars['Boolean'];
  showAttendees: Scalars['Boolean'];
  streamIsContinues: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  virtualSpace?: Maybe<SpaceType>;
  mapitem?: Maybe<EventMapItemType>;
  tags?: Maybe<Array<TagType>>;
  onlyForSegments?: Maybe<Array<SegmentType>>;
  sponsor?: Maybe<SponsorType>;
  container?: Maybe<ShowContainerType>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  attachment?: Maybe<Scalars['String']>;
  attachmentName?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  name?: Maybe<Scalars['String']>;
  performers: PerformerConnection;
  slug?: Maybe<Scalars['String']>;
  virtualImage?: Maybe<Scalars['AbsoluteUpload']>;
};


export type ShowTypePerformersArgs = {
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type SpaceConnection = {
  edges: Array<Maybe<SpaceEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type SpaceEdge = {
  cursor: Scalars['Int'];
  node: SpaceType;
};

export type SpaceFilter = {
  id?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
};

export type SpaceType = {
  id: Scalars['Int'];
  dateChanged: Scalars['DateTime'];
  helpContent?: Maybe<Scalars['String']>;
  helpContentType: Scalars['String'];
  timetableOrder: Scalars['Int'];
  created: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  published: Scalars['Boolean'];
  enableChat: Scalars['Boolean'];
  linkedFrom: Array<SpaceType>;
  presentationFields?: Maybe<PresentationSpaceType>;
};

export enum SpaceTypeEnum {
  Booth = 'booth',
  Cinema = 'cinema',
  Jobs = 'jobs',
  Map = 'map',
  Meeting = 'meeting',
  Networking = 'networking',
  Presentation = 'presentation',
  Posters = 'posters',
  ChatRoulette = 'chat_roulette',
  Embedded = 'embedded'
}

export type SponsorType = {
  id: Scalars['Int'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type StrFilterLookup = {
  exact?: Maybe<Scalars['String']>;
  iExact?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  iContains?: Maybe<Scalars['String']>;
  inList?: Maybe<Array<Scalars['String']>>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  iStartsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  iEndsWith?: Maybe<Scalars['String']>;
  range?: Maybe<Array<Scalars['String']>>;
  isNull?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<Scalars['String']>;
  iRegex?: Maybe<Scalars['String']>;
};

export type TagCategoryType = {
  id: Scalars['Int'];
  text: Scalars['String'];
  order: Scalars['Int'];
};

export type TagType = {
  id: Scalars['Int'];
  text: Scalars['String'];
  order: Scalars['Int'];
  color: Scalars['String'];
  category?: Maybe<TagCategoryType>;
};

export enum TimeFormat {
  Format12Hour = 'FORMAT12HOUR',
  Format24Hour = 'FORMAT24HOUR'
}

export type UpdateBooth = {
  maxStaff?: Maybe<Scalars['Int']>;
  maxVideos?: Maybe<Scalars['Int']>;
  maxDocuments?: Maybe<Scalars['Int']>;
  maxJobOpenings?: Maybe<Scalars['Int']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  enableVideocall?: Maybe<Scalars['Boolean']>;
  enableSpecialOffers?: Maybe<Scalars['Boolean']>;
  enableRequestSample?: Maybe<Scalars['Boolean']>;
  enableAppointments?: Maybe<Scalars['Boolean']>;
  enableVisitorList?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  companyLogo?: Maybe<Scalars['AbsoluteUpload']>;
  boothLogo?: Maybe<Scalars['AbsoluteUpload']>;
  contactEmail?: Maybe<Scalars['Email']>;
  website?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<BoothTypeOption>;
  parent?: Maybe<UpdateSpace>;
  inviteStaff?: Maybe<Scalars['Email']>;
  removeStaff?: Maybe<Scalars['Email']>;
  physicalLocationId?: Maybe<Scalars['ID']>;
  categories?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateCinema = {
  parent?: Maybe<UpdateSpace>;
};

export type UpdateEmbeddedSpaceInput = {
  url?: Maybe<Scalars['String']>;
  parent?: Maybe<UpdateSpace>;
};

export type UpdateEventInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  primaryBrandColor?: Maybe<Scalars['String']>;
  secondaryBrandColor?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
  privacyStatement?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['ID']>;
  inviteOnly?: Maybe<Scalars['Boolean']>;
  inviteMailSenderName?: Maybe<Scalars['String']>;
  inviteMailReplyTo?: Maybe<Scalars['String']>;
  inviteMailSubject?: Maybe<Scalars['String']>;
  inviteMailSalutation?: Maybe<Scalars['String']>;
  language?: Maybe<EventLanguage>;
  slug?: Maybe<Scalars['SlugField']>;
  virtual?: Maybe<UpdateVirtualEventInput>;
  resellerConfig?: Maybe<EventResellerConfigInput>;
  inviteMailNameFormat?: Maybe<NameFormat>;
  inviteMailIntro?: Maybe<Scalars['String']>;
  inviteMailOutro?: Maybe<Scalars['String']>;
  timeFormat?: Maybe<TimeFormat>;
};

export type UpdateGroupSession = {
  id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  endsAt: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
};

export type UpdateInvite = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['Email']>;
  jobtitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  googlePlus?: Maybe<Scalars['String']>;
  locationType?: Maybe<LocationType>;
  tags?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateMapItem = {
  name?: Maybe<Scalars['String']>;
  shape?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  widget?: Maybe<WidgetType>;
  widgetLink?: Maybe<Scalars['String']>;
  forMobile?: Maybe<Scalars['Boolean']>;
  coords?: Maybe<Array<Scalars['Int']>>;
  mapId?: Maybe<Scalars['ID']>;
  spaceId?: Maybe<Scalars['ID']>;
};

export type UpdateMapSpaceInput = {
  backgroundColor?: Maybe<Scalars['String']>;
  parent?: Maybe<UpdateSpace>;
};

export type UpdateMeeting = {
  title?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  closed?: Maybe<Scalars['Boolean']>;
  capacity?: Maybe<Scalars['Int']>;
  enableBreakoutRooms?: Maybe<Scalars['Boolean']>;
  isWalkInMeeting?: Maybe<Scalars['Boolean']>;
  programItemId?: Maybe<Scalars['ID']>;
};

export type UpdateMeetingSpace = {
  parent?: Maybe<UpdateSpace>;
};

export type UpdateMeetingUser = {
  role?: Maybe<RoleChoices>;
};

export type UpdateMovie = {
  title?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
  imageThumbnail?: Maybe<Scalars['AbsoluteUpload']>;
  cinemaId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateNavigationItem = {
  text?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  submenuId?: Maybe<Scalars['ID']>;
  spaceId?: Maybe<Scalars['ID']>;
  linkedSpaceId?: Maybe<Scalars['ID']>;
};

export type UpdateNavigationMenu = {
  text?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type UpdateNavigationSubMenu = {
  text?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  menuId?: Maybe<Scalars['ID']>;
};

export type UpdateNetworkingSpaceInput = {
  parent?: Maybe<UpdateSpace>;
};

export type UpdateOrganization = {
  contactName?: Maybe<Scalars['String']>;
  contactPosition?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['Email']>;
  contactPhone?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<AddressInput>;
  physicalAddress?: Maybe<AddressInput>;
  billingAddressIsPhysicalAddress?: Maybe<Scalars['Boolean']>;
  cocNumber?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  billingDepartment?: Maybe<Scalars['String']>;
  language?: Maybe<OrganizationLanguage>;
};

export type UpdatePerformer = {
  name?: Maybe<Scalars['String']>;
  jobtitle?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  mugshot?: Maybe<Scalars['AbsoluteUpload']>;
  about?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  attachmentName?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
};

export type UpdatePosterInput = {
  title?: Maybe<Scalars['String']>;
  abstract?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['AbsoluteUpload']>;
  pdf?: Maybe<Scalars['AbsoluteUpload']>;
  authorNames?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  locationType?: Maybe<LocationType>;
  published?: Maybe<Scalars['Boolean']>;
  authorEmail?: Maybe<Scalars['Email']>;
  spaceId?: Maybe<Scalars['ID']>;
};

export type UpdatePosterSpaceInput = {
  enableVideo?: Maybe<Scalars['Boolean']>;
  enableMessaging?: Maybe<Scalars['Boolean']>;
  posterSorting?: Maybe<PosterSorting>;
  parent?: Maybe<UpdateSpace>;
};

export type UpdatePresentationSpaceInput = {
  streamIsContinues?: Maybe<Scalars['Boolean']>;
  streamUrl?: Maybe<Scalars['String']>;
  interactionIsContinues?: Maybe<Scalars['Boolean']>;
  interactionUrl?: Maybe<Scalars['String']>;
  showAttendees?: Maybe<Scalars['Boolean']>;
  parent?: Maybe<UpdateSpace>;
};

export type UpdateShow = {
  name?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  virtualImage?: Maybe<Scalars['AbsoluteUpload']>;
  attachment?: Maybe<Scalars['AbsoluteUpload']>;
  attachmentName?: Maybe<Scalars['String']>;
  moderatorEmail?: Maybe<Scalars['Email']>;
  streamUrl?: Maybe<Scalars['String']>;
  embeddedUrl?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  showAttendees?: Maybe<Scalars['Boolean']>;
  streamIsContinues?: Maybe<Scalars['Boolean']>;
  virtualSpaceId?: Maybe<Scalars['Int']>;
  mapitemId?: Maybe<Scalars['Int']>;
  containerId?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  performerIds?: Maybe<Array<Scalars['Int']>>;
  tags?: Maybe<Array<Scalars['Int']>>;
  segments?: Maybe<Array<Scalars['Int']>>;
  sponsorId?: Maybe<Scalars['Int']>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
};

export type UpdateShowContainer = {
  externalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  playbackUrl?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  sponsorId?: Maybe<Scalars['ID']>;
  virtualSpaceId?: Maybe<Scalars['ID']>;
  mapitemId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Scalars['ID']>>;
};

export type UpdateSpace = {
  name?: Maybe<Scalars['String']>;
  helpContent?: Maybe<Scalars['String']>;
  helpContentType?: Maybe<Scalars['String']>;
  enableChat?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Scalars['AbsoluteUpload']>;
  timetableOrder?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Boolean']>;
};

export type UpdateTag = {
  text?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['ID']>;
};

export type UpdateTagCategory = {
  text?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type UpdateVirtualEventInput = {
  homeSpaceId?: Maybe<Scalars['ID']>;
  autostartIntroVideo?: Maybe<Scalars['Boolean']>;
  introVideo?: Maybe<Scalars['String']>;
  introText?: Maybe<Scalars['String']>;
  loginFormAddendum?: Maybe<Scalars['String']>;
  helpContent?: Maybe<Scalars['String']>;
  helpContentType?: Maybe<Scalars['String']>;
  goodiebagName?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['AbsoluteUpload']>;
  backgroundImage?: Maybe<Scalars['AbsoluteUpload']>;
  showAttendeeListOutside?: Maybe<Scalars['Boolean']>;
  startWithLoginTab?: Maybe<Scalars['Boolean']>;
  showBoothSidebar?: Maybe<Scalars['Boolean']>;
  showSpeakerIcon?: Maybe<Scalars['Boolean']>;
  showCalendarIcon?: Maybe<Scalars['Boolean']>;
};

export type UserConnection = {
  edges: Array<Maybe<UserEdge>>;
  pageInfo: Pagination;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  cursor: Scalars['Int'];
  node: UserType;
};

export type UserType = {
  id: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['Email'];
  about: Scalars['String'];
  company: Scalars['String'];
  hasLoggedOn: Scalars['Boolean'];
  isSuperUser: Scalars['Boolean'];
  jobtitle: Scalars['String'];
  mugshot: Scalars['String'];
};

export enum WidgetType {
  Reception = 'reception',
  EventInfo = 'event_info',
  ExternalLink = 'external_link',
  Embedded = 'embedded'
}

export type GetMyEventsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
}>;


export type GetMyEventsQuery = { myEvents: { edges: Array<Maybe<{ node: Pick<EventType, 'id' | 'name' | 'slug' | 'startDate' | 'endDate'> }>> }, currentUser: Pick<UserType, 'id' | 'isSuperUser'> };

export type GetMyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationsQuery = { myOrganizations: { edges: Array<Maybe<{ node: Pick<OrganizationType, 'id' | 'name' | 'language'> }>> } };

export type MyEventsFragment = Pick<EventType, 'id' | 'name' | 'slug' | 'startDate' | 'endDate'>;

export type InviteAdminMutationVariables = Exact<{
  data: InviteAdmin;
}>;


export type InviteAdminMutation = Pick<Mutation, 'inviteAdmin'>;

export type RemoveAdminMutationVariables = Exact<{
  data: RemoveAdmin;
}>;


export type RemoveAdminMutation = Pick<Mutation, 'removeAdmin'>;

export type GetAdminsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type GetAdminsQuery = { event: { admins: { edges: Array<Maybe<{ node: Pick<UserType, 'id' | 'firstName' | 'lastName' | 'email' | 'mugshot' | 'hasLoggedOn'> }>> } } };

export type SendTestEmailMutationVariables = Exact<{
  eventSlug: Scalars['EventID'];
}>;


export type SendTestEmailMutation = Pick<Mutation, 'sendTestEmailToCurrentUser'>;

export type SendInviteEmailsMutationVariables = Exact<{
  data: SendInviteEmails;
}>;


export type SendInviteEmailsMutation = { sendInviteEmails: Array<Pick<InviteType, 'email' | 'status' | 'mailSent'>> };

export type SendBatchEmailsMutationVariables = Exact<{
  data: QueueBatchInviteEmails;
}>;


export type SendBatchEmailsMutation = Pick<Mutation, 'queueBatchInviteEmails'>;

export type CreateInviteMutationVariables = Exact<{
  data: CreateInvite;
}>;


export type CreateInviteMutation = { createInvite: Pick<InviteType, 'id'> };

export type UpdateInviteMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateInvite;
}>;


export type UpdateInviteMutation = { updateInvite: Pick<InviteType, 'id'> };

export type DeleteInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInviteMutation = Pick<Mutation, 'deleteInvite'>;

export type SetIsStaffMutationVariables = Exact<{
  data: SetIsStaff;
}>;


export type SetIsStaffMutation = Pick<Mutation, 'setIsStaff'>;

export type ActiveEventMutationVariables = Exact<{
  eventSlug: Scalars['EventID'];
}>;


export type ActiveEventMutation = { requestEventActivation: Pick<EventType, 'id' | 'isActivationRequested'> };

export type ImportAttendeesMutationVariables = Exact<{
  eventSlug: Scalars['EventID'];
  data: Array<ImportInvite> | ImportInvite;
}>;


export type ImportAttendeesMutation = { importInvites: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type CreateAttendeeTagCategoryMutationVariables = Exact<{
  data: CreateTagCategory;
}>;


export type CreateAttendeeTagCategoryMutation = { createAttendeeTagCategory: Pick<TagCategoryType, 'id'> };

export type CreateAttendeeTagMutationVariables = Exact<{
  data: CreateTag;
}>;


export type CreateAttendeeTagMutation = { createAttendeeTag: Pick<TagType, 'id'> };

export type UpdateAttendeeTagMutationVariables = Exact<{
  data: UpdateTag;
  id: Scalars['ID'];
}>;


export type UpdateAttendeeTagMutation = { updateAttendeeTag: Pick<TagType, 'id'> };

export type DeleteAttendeeTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAttendeeTagMutation = Pick<Mutation, 'deleteAttendeeTag'>;

export type UpdateAttendeeTagCategoryMutationVariables = Exact<{
  data: UpdateTagCategory;
  id: Scalars['ID'];
}>;


export type UpdateAttendeeTagCategoryMutation = { updateAttendeeTagCategory: Pick<TagCategoryType, 'id'> };

export type DeleteAttendeeTagCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAttendeeTagCategoryMutation = Pick<Mutation, 'deleteAttendeeTagCategory'>;

export type GetInvitesQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
  sort?: Maybe<InviteOrder>;
  status?: Maybe<InviteStatus>;
}>;


export type GetInvitesQuery = { event: { invites?: Maybe<(
      Pick<EventInviteConnection, 'totalCount'>
      & { edges: Array<Maybe<{ node: (
          Pick<InviteType, 'id' | 'firstName' | 'lastName' | 'email' | 'created' | 'mailSent' | 'status' | 'isStaff'>
          & { tags: Array<Pick<TagType, 'color' | 'text'>> }
        ) }>>, pageInfo: Pick<Pagination, 'hasNextPage' | 'hasPreviousPage' | 'endCursor'> }
    )> } };

export type GetEventInviteConfigQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
}>;


export type GetEventInviteConfigQuery = { event: Pick<EventType, 'isActivationRequested' | 'paid' | 'inviteOnly' | 'inviteMailSenderName' | 'inviteMailReplyTo' | 'inviteMailSubject' | 'inviteMailNameFormat' | 'inviteMailSalutation' | 'inviteMailIntro' | 'inviteMailOutro'> };

export type GetInviteByIdQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
  filters?: Maybe<EventInviteFilter>;
}>;


export type GetInviteByIdQuery = { event: { invites?: Maybe<{ edges: Array<Maybe<{ node: (
          Pick<InviteType, 'id' | 'firstName' | 'lastName' | 'email' | 'jobtitle' | 'company' | 'about' | 'website' | 'twitter' | 'facebook' | 'linkedin' | 'instagram' | 'googlePlus' | 'status' | 'locationType'>
          & { tags: Array<Pick<TagType, 'id' | 'text' | 'color'>> }
        ) }>> }> } };

export type GetStatusOverviewQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
  status?: Maybe<InviteStatus>;
}>;


export type GetStatusOverviewQuery = { event: { invites?: Maybe<Pick<EventInviteConnection, 'totalCount'>> } };

export type GetAttendeeTagsQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
}>;


export type GetAttendeeTagsQuery = { event: { userTags?: Maybe<Array<(
      Pick<TagType, 'id' | 'text' | 'color'>
      & { category?: Maybe<Pick<TagCategoryType, 'id' | 'text' | 'order'>> }
    )>> } };

export type UserTagsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type UserTagsQuery = { event: { userTags?: Maybe<Array<(
      Pick<TagType, 'id' | 'text' | 'color' | 'order'>
      & { category?: Maybe<Pick<TagCategoryType, 'id' | 'text' | 'order'>> }
    )>> } };

export type AttendeeTagCategoriesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type AttendeeTagCategoriesQuery = { event: { attendeeTagCategories?: Maybe<Array<Pick<TagCategoryType, 'id' | 'order' | 'text'>>> } };

export type UpdateBoothMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateBooth;
}>;


export type UpdateBoothMutation = { updateBooth: (
    Pick<BoothType, 'id'>
    & { staffMembers: Array<Pick<UserType, 'id' | 'email' | 'hasLoggedOn'>> }
  ) };

export type CreateBoothMutationVariables = Exact<{
  eventId: Scalars['EventID'];
  data: CreateBooth;
}>;


export type CreateBoothMutation = { createBooth: Pick<BoothType, 'id'> };

export type DeleteBoothMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBoothMutation = Pick<Mutation, 'deleteSpace'>;

export type BoothsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  eventId: Scalars['EventID'];
  filters?: Maybe<BoothSpaceFilter>;
  search?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BoothsQuery = { event: (
    Pick<EventType, 'showBoothSidebar'>
    & { booths: { edges: Array<Maybe<{ node: (
          Pick<BoothType, 'id' | 'boothLogo' | 'companyLogo' | 'subtitle' | 'order' | 'type' | 'maxStaff' | 'maxVideos' | 'maxDocuments' | 'maxJobOpenings' | 'enableChat' | 'enableVideocall' | 'enableVisitorList'>
          & { parent: (
            Pick<SpaceType, 'slug' | 'name'>
            & { linkedFrom: Array<Pick<SpaceType, 'id' | 'name' | 'slug'>> }
          ), staffMembers: Array<Pick<UserType, 'id' | 'email' | 'hasLoggedOn'>>, videos?: Maybe<Array<Pick<BoothVideoType, 'id'>>>, documents?: Maybe<Array<Pick<BoothDocumentType, 'id'>>>, categories: Array<Pick<BoothCategoryType, 'id' | 'name'>>, physicalLocation?: Maybe<Pick<EventMapItemType, 'id'>> }
        ) }>> } }
  ) };

export type GetMapSpacesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  type?: Maybe<SpaceTypeEnum>;
}>;


export type GetMapSpacesQuery = { event: { spaces?: Maybe<{ edges: Array<Maybe<{ node: Pick<SpaceType, 'id' | 'name'> }>> }> } };

export type GetBoothCategoriesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type GetBoothCategoriesQuery = { event: { boothCategories?: Maybe<Array<Pick<BoothCategoryType, 'id' | 'name'>>> } };

export type CreateMovieMutationVariables = Exact<{
  data: CreateMovie;
}>;


export type CreateMovieMutation = { createMovie: Pick<MovieType, 'id'> };

export type UpdateMovieMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateMovie;
}>;


export type UpdateMovieMutation = { updateMovie: Pick<MovieType, 'id'> };

export type DeleteMovieMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMovieMutation = Pick<Mutation, 'deleteMovie'>;

export type UpdateCinemaMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateCinema;
}>;


export type UpdateCinemaMutation = { updateCinema: (
    Pick<CinemaType, 'id'>
    & { parent: Pick<SpaceType, 'image'> }
  ) };

export type ImportMovieMutationVariables = Exact<{
  cinemaSpace: Scalars['ID'];
  data: Array<ImportMovie> | ImportMovie;
}>;


export type ImportMovieMutation = { importMovie: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type CreateMovieTagCategoryMutationVariables = Exact<{
  data: CreateMovieTagCategory;
}>;


export type CreateMovieTagCategoryMutation = { createMovieTagCategory: Pick<TagCategoryType, 'id'> };

export type CreateMovieTagMutationVariables = Exact<{
  data: CreateTag;
}>;


export type CreateMovieTagMutation = { createMovieTag: Pick<TagType, 'id'> };

export type UpdateMovieTagMutationVariables = Exact<{
  data: UpdateTag;
  id: Scalars['ID'];
}>;


export type UpdateMovieTagMutation = { updateMovieTag: Pick<TagType, 'id'> };

export type DeleteMovieTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMovieTagMutation = Pick<Mutation, 'deleteMovieTag'>;

export type UpdateMovieTagCategoryMutationVariables = Exact<{
  data: UpdateTagCategory;
  id: Scalars['ID'];
}>;


export type UpdateMovieTagCategoryMutation = { updateMovieTagCategory: Pick<TagCategoryType, 'id'> };

export type DeleteMovieTagCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMovieTagCategoryMutation = Pick<Mutation, 'deleteMovieTagCategory'>;

export type CinemaFragment = (
  Pick<CinemaType, 'id'>
  & { parent: Pick<SpaceType, 'name' | 'image' | 'published' | 'helpContent' | 'helpContentType' | 'slug'>, movies?: Maybe<{ edges: Array<Maybe<{ node: (
        Pick<MovieType, 'id' | 'title' | 'subtitle' | 'embeddedUrl' | 'published' | 'order' | 'imageThumbnail'>
        & { cinema: Pick<CinemaType, 'id'>, tags?: Maybe<Array<Pick<TagType, 'id' | 'text' | 'color'>>> }
      ) }>> }> }
);

export type GetVideosQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  first?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
}>;


export type GetVideosQuery = { event: { cinemas: { edges: Array<Maybe<{ node: CinemaFragment }>> } } };

export type MovieTagsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type MovieTagsQuery = { event: { movieTags?: Maybe<Array<(
      Pick<TagType, 'id' | 'text' | 'color' | 'order'>
      & { category?: Maybe<Pick<TagCategoryType, 'id' | 'text' | 'order'>> }
    )>> } };

export type MovieTagCategoriesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type MovieTagCategoriesQuery = { event: { movieTagCategories?: Maybe<Array<Pick<TagCategoryType, 'id' | 'order' | 'text'>>> } };

export type UpdateEmbeddedSpaceMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateEmbeddedSpaceInput;
}>;


export type UpdateEmbeddedSpaceMutation = { updateEmbeddedSpace: Pick<EmbeddedSpaceType, 'id'> };

export type GetEmbeddedSpaceQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  filters?: Maybe<EmbeddedSpaceFilter>;
}>;


export type GetEmbeddedSpaceQuery = { event: { embeddedSpaces: { edges: Array<Maybe<{ node: (
          Pick<EmbeddedSpaceType, 'id' | 'url'>
          & { parent: Pick<SpaceType, 'name' | 'helpContent' | 'helpContentType'> }
        ) }>> } } };

export type CreateEventMutationVariables = Exact<{
  data: CreateEvent;
}>;


export type CreateEventMutation = { createEvent: Pick<EventType, 'id' | 'slug'> };

export type MyOrganizationFragment = Pick<OrganizationType, 'id' | 'name' | 'language'>;

export type MyOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOrganizationQuery = { myOrganizations: (
    Pick<OrganizationConnection, 'totalCount'>
    & { edges: Array<Maybe<{ node: MyOrganizationFragment }>> }
  ) };

export type CreateEventImageMutationVariables = Exact<{
  data: EventImageInput;
}>;


export type CreateEventImageMutation = { createEventImage: Pick<EventImageType, 'id' | 'file'> };

export type RemoveUserDataFromEventMutationVariables = Exact<{
  event: Scalars['EventID'];
}>;


export type RemoveUserDataFromEventMutation = Pick<Mutation, 'removeUserDataFromEvent'>;

export type UpdateEventMutationVariables = Exact<{
  event: Scalars['EventID'];
  data: UpdateEventInput;
}>;


export type UpdateEventMutation = { updateEvent: Pick<EventType, 'id' | 'virtualEventLogo' | 'backgroundImage'> };

export type RequestEventActivationMutationVariables = Exact<{
  event: Scalars['EventID'];
}>;


export type RequestEventActivationMutation = { requestEventActivation: Pick<EventType, 'id'> };

export type EventQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type EventQuery = { event: (
    Pick<EventType, 'published' | 'firstPublishedAt' | 'paid' | 'isActivationRequested' | 'name' | 'slug' | 'startDate' | 'endDate' | 'goodiebagName' | 'timezone' | 'timeFormat' | 'description' | 'language' | 'virtualEventLogo' | 'backgroundImage' | 'primaryBrandColor' | 'secondaryBrandColor' | 'textEventPreview' | 'introVideo' | 'autostartVideo' | 'loginFormAddendum' | 'terms' | 'privacyStatement' | 'helpContent' | 'helpContentType' | 'currentUserHasResellerAccess' | 'maxSpaces' | 'maxBooths' | 'maxParticipants' | 'maxDurationInDays' | 'openedDaysLeft' | 'maxDaysWithNetworking' | 'networkingDaysLeft' | 'enableChatCarousel' | 'enableGroupSessions' | 'amountOfParticipants' | 'maxOwners' | 'startWithLoginTab' | 'userDataIsDeleted' | 'hasPublishedNetworking' | 'showBoothSidebar' | 'showSpeakerIcon' | 'showCalendarIcon' | 'enablePageTranslation'>
    & { homeSpace?: Maybe<Pick<SpaceType, 'id' | 'name'>>, spaces?: Maybe<(
      Pick<SpaceConnection, 'totalCount'>
      & { edges: Array<Maybe<{ node: Pick<SpaceType, 'id' | 'type' | 'slug' | 'name' | 'published' | 'timetableOrder'> }>> }
    )>, organization?: Maybe<Pick<OrganizationType, 'id' | 'subdomain'>>, maps: Array<(
      Pick<EventMapType, 'id' | 'name'>
      & { mapitems?: Maybe<Array<Pick<EventMapItemType, 'id' | 'name'>>> }
    )> }
  ) };

export type CreateGroupSessionMutationVariables = Exact<{
  data: CreateGroupSession;
}>;


export type CreateGroupSessionMutation = { createGroupSession: Pick<GroupSessionType, 'id'> };

export type UpdateGroupSessionMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateGroupSession;
}>;


export type UpdateGroupSessionMutation = { updateGroupSession: Pick<GroupSessionType, 'id'> };

export type DeleteGroupSessionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteGroupSessionMutation = Pick<Mutation, 'deleteGroupSession'>;

export type AddGroupSessionAttendeeMutationVariables = Exact<{
  data: AddGroupSessionAttendee;
}>;


export type AddGroupSessionAttendeeMutation = { addGroupSessionAttendee: Pick<UserType, 'about' | 'company' | 'email' | 'firstName' | 'hasLoggedOn' | 'id' | 'jobtitle' | 'lastName' | 'mugshot'> };

export type RemoveGroupSessionAttendeeMutationVariables = Exact<{
  data: RemoveGroupSessionAttendee;
}>;


export type RemoveGroupSessionAttendeeMutation = Pick<Mutation, 'removeGroupSessionAttendee'>;

export type GroupSessionsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
  filters?: Maybe<GroupSessionFilter>;
  eventId: Scalars['EventID'];
}>;


export type GroupSessionsQuery = { event: { groupSessions: (
      Pick<GroupSessionConnection, 'totalCount'>
      & { edges: Array<Maybe<{ node: (
          Pick<GroupSessionType, 'id' | 'title' | 'startsAt' | 'endsAt' | 'description'>
          & { participants: (
            Pick<UserConnection, 'totalCount'>
            & { edges: Array<Maybe<{ node: Pick<UserType, 'company' | 'email' | 'firstName' | 'id' | 'jobtitle' | 'lastName' | 'mugshot' | 'about' | 'hasLoggedOn'> }>> }
          ) }
        ) }>>, pageInfo: Pick<Pagination, 'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'> }
    ) } };

export type CreateImageMutationVariables = Exact<{
  data: CreateImage;
}>;


export type CreateImageMutation = { createImage: Pick<ImageType, 'id' | 'file'> };

export type DeleteImageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteImageMutation = Pick<Mutation, 'deleteImage'>;

export type LibraryImagesQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
}>;


export type LibraryImagesQuery = { event: { organization?: Maybe<(
      Pick<OrganizationType, 'id'>
      & { images?: Maybe<{ edges: Array<Maybe<{ node: Pick<ImageType, 'id' | 'file'> }>> }> }
    )> } };

export type OrganizationImagesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationImagesQuery = { organization: { images?: Maybe<{ edges: Array<Maybe<{ node: Pick<ImageType, 'id' | 'file'> }>> }> } };

export type UpdateMapSpaceMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateMapSpaceInput;
}>;


export type UpdateMapSpaceMutation = { updateMapSpace: (
    Pick<MapSpaceType, 'id'>
    & { parent: Pick<SpaceType, 'image'> }
  ) };

export type UpdateMapItemMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateMapItem;
}>;


export type UpdateMapItemMutation = { updateMapItem: Pick<MapItemType, 'id'> };

export type DeleteMapItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMapItemMutation = Pick<Mutation, 'deleteMapItem'>;

export type CreateMapItemMutationVariables = Exact<{
  data: CreateMapItem;
}>;


export type CreateMapItemMutation = { createMapItem: Pick<MapItemType, 'id'> };

export type MapItemFragment = (
  Pick<MapItemType, 'id' | 'name' | 'embeddedUrl' | 'widgetLink' | 'widget' | 'coords' | 'shape' | 'forMobile'>
  & { space?: Maybe<Pick<SpaceType, 'id' | 'name' | 'type'>> }
);

export type MapSpaceQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
  filters?: Maybe<MapSpaceFilter>;
}>;


export type MapSpaceQuery = { event: { mapSpaces: { edges: Array<Maybe<{ node: (
          Pick<MapSpaceType, 'id'>
          & { items?: Maybe<Array<MapItemFragment>>, parent: Pick<SpaceType, 'name' | 'enableChat' | 'published' | 'helpContent' | 'helpContentType' | 'image' | 'slug'> }
        ) }>> } } };

export type UpdateMeetingSpaceMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateMeetingSpace;
}>;


export type UpdateMeetingSpaceMutation = { updateMeetingSpace: (
    Pick<MeetingSpaceType, 'id'>
    & { parent: Pick<SpaceType, 'image'> }
  ) };

export type CreateMeetingMutationVariables = Exact<{
  data: CreateMeeting;
}>;


export type CreateMeetingMutation = { createMeeting: Pick<MeetingType, 'id'> };

export type UpdateMeetingMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateMeeting;
}>;


export type UpdateMeetingMutation = { updateMeeting: Pick<MeetingType, 'id'> };

export type DeleteMeetingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMeetingMutation = Pick<Mutation, 'deleteMeeting'>;

export type AddParticipantMutationVariables = Exact<{
  data: AddMeetingUser;
}>;


export type AddParticipantMutation = { addMeetingUser: Pick<MeetingUserType, 'id'> };

export type RemoveParticipantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveParticipantMutation = Pick<Mutation, 'removeMeetingUser'>;

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateMeetingUser;
}>;


export type UpdateRoleMutation = { updateMeetingUser: Pick<MeetingUserType, 'id' | 'role'> };

export type ImportMeetingMutationVariables = Exact<{
  meetingSpace: Scalars['ID'];
  data: Array<ImportMeeting> | ImportMeeting;
}>;


export type ImportMeetingMutation = { importMeeting: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type ImportMeetingParticipantsMutationVariables = Exact<{
  meetingSpace: Scalars['ID'];
  data: Array<ImportMeetingParticipant> | ImportMeetingParticipant;
}>;


export type ImportMeetingParticipantsMutation = { importMeetingParticipants: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type GetMeetingSpaceQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  spaceFilters?: Maybe<MeetingSpaceFilter>;
}>;


export type GetMeetingSpaceQuery = { event: { meetingSpaces: { edges: Array<Maybe<{ node: (
          Pick<MeetingSpaceType, 'id'>
          & { parent: Pick<SpaceType, 'id' | 'image' | 'name' | 'slug' | 'published' | 'enableChat' | 'helpContent' | 'helpContentType'> }
        ) }>> } } };

export type MeetingFragmentFragment = (
  Pick<MeetingType, 'id' | 'title' | 'capacity' | 'capacityLeft' | 'startsAt' | 'endsAt' | 'enableBreakoutRooms' | 'closed' | 'isWalkInMeeting' | 'description'>
  & { programItem?: Maybe<Pick<ShowType, 'id' | 'name'>>, hosts: Pick<MeetingUserConnection, 'totalCount'> }
);

export type GetMeetingsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
  sort?: Maybe<MeetingOrder>;
  date?: Maybe<Scalars['Date']>;
  spaceFilters?: Maybe<MeetingSpaceFilter>;
  meetingFilters?: Maybe<MeetingFilter>;
}>;


export type GetMeetingsQuery = { event: { meetingSpaces: { edges: Array<Maybe<{ node: { meetings: (
            Pick<MeetingConnection, 'totalCount'>
            & { edges: Array<Maybe<{ node: MeetingFragmentFragment }>>, pageInfo: Pick<Pagination, 'hasPreviousPage' | 'hasNextPage' | 'endCursor'> }
          ) } }>> } } };

export type ParticipantFragment = (
  Pick<MeetingUserType, 'id' | 'role'>
  & { user: Pick<UserType, 'id' | 'mugshot' | 'firstName' | 'lastName' | 'jobtitle' | 'company' | 'email' | 'hasLoggedOn'> }
);

export type GetParticipantsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  spaceFilters?: Maybe<MeetingSpaceFilter>;
  meetingFilters?: Maybe<MeetingFilter>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
}>;


export type GetParticipantsQuery = { event: { meetingSpaces: { edges: Array<Maybe<{ node: { meetings: { edges: Array<Maybe<{ node: { participants: (
                  Pick<MeetingUserConnection, 'totalCount'>
                  & { edges: Array<Maybe<{ node: ParticipantFragment }>>, pageInfo: Pick<Pagination, 'hasPreviousPage' | 'hasNextPage' | 'endCursor'> }
                ) } }>> } } }>> } } };

export type GetHostsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  spaceFilters?: Maybe<MeetingSpaceFilter>;
  meetingFilters?: Maybe<MeetingFilter>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
}>;


export type GetHostsQuery = { event: { meetingSpaces: { edges: Array<Maybe<{ node: { meetings: { edges: Array<Maybe<{ node: { hosts: (
                  Pick<MeetingUserConnection, 'totalCount'>
                  & { edges: Array<Maybe<{ node: ParticipantFragment }>>, pageInfo: Pick<Pagination, 'hasPreviousPage' | 'hasNextPage' | 'endCursor'> }
                ) } }>> } } }>> } } };

export type CreateNavigationItemMutationVariables = Exact<{
  input: CreateNavigationItem;
}>;


export type CreateNavigationItemMutation = { createNavigationItem: (
    Pick<NavigationItemType, 'id' | 'order' | 'text'>
    & { space: Pick<SpaceType, 'id'> }
  ) };

export type CreateNavigationMenuMutationVariables = Exact<{
  input: CreateNavigationMenu;
}>;


export type CreateNavigationMenuMutation = { createNavigationMenu: Pick<NavigationMenuType, 'id' | 'order' | 'text'> };

export type CreateNavigationSubMenuMutationVariables = Exact<{
  input: CreateNavigationSubMenu;
}>;


export type CreateNavigationSubMenuMutation = { createNavigationSubMenu: Pick<NavigationSubMenuType, 'id' | 'order' | 'text'> };

export type UpdateNavigationItemMutationVariables = Exact<{
  data: UpdateNavigationItem;
  id: Scalars['ID'];
}>;


export type UpdateNavigationItemMutation = { updateNavigationItem: (
    Pick<NavigationItemType, 'id' | 'order' | 'text'>
    & { space: Pick<SpaceType, 'id'>, linkedSpace?: Maybe<Pick<SpaceType, 'id'>> }
  ) };

export type UpdateNavigationMenuMutationVariables = Exact<{
  data: UpdateNavigationMenu;
  id: Scalars['ID'];
}>;


export type UpdateNavigationMenuMutation = { updateNavigationMenu: Pick<NavigationItemType, 'id' | 'order' | 'text'> };

export type UpdateNavigationSubMenuMutationVariables = Exact<{
  data: UpdateNavigationSubMenu;
  id: Scalars['ID'];
}>;


export type UpdateNavigationSubMenuMutation = { updateNavigationSubMenu: Pick<NavigationSubMenuType, 'id' | 'order' | 'text'> };

export type DeleteNavigationItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNavigationItemMutation = Pick<Mutation, 'deleteNavigationItem'>;

export type DeleteNavigationMenuMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNavigationMenuMutation = Pick<Mutation, 'deleteNavigationMenu'>;

export type DeleteNavigationSubMenuMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNavigationSubMenuMutation = Pick<Mutation, 'deleteNavigationSubMenu'>;

export type NavigationMenusQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type NavigationMenusQuery = { event: { navigationItems: Array<(
      Pick<NavigationItemType, 'id' | 'order' | 'text'>
      & { space: Pick<SpaceType, 'id'>, linkedSpace?: Maybe<Pick<SpaceType, 'id'>> }
    )>, navigationMenus: Array<(
      Pick<NavigationMenuType, 'id' | 'order' | 'text'>
      & { subMenus?: Maybe<Array<(
        Pick<NavigationSubMenuType, 'id' | 'order' | 'text'>
        & { items?: Maybe<Array<(
          Pick<NavigationItemType, 'id' | 'order' | 'text'>
          & { space: Pick<SpaceType, 'id'>, linkedSpace?: Maybe<Pick<SpaceType, 'id'>> }
        )>> }
      )>> }
    )> } };

export type GetSpacesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  first?: Maybe<Scalars['Int']>;
}>;


export type GetSpacesQuery = { event: { spaces?: Maybe<{ edges: Array<Maybe<{ node: (
          Pick<SpaceType, 'id' | 'name' | 'type'>
          & { linkedFrom: Array<Pick<SpaceType, 'id' | 'name' | 'type'>> }
        ) }>> }> } };

export type UpdateNetworkingMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateNetworkingSpaceInput;
}>;


export type UpdateNetworkingMutation = { updateNetworkingSpace: (
    Pick<NetworkingSpaceType, 'id'>
    & { parent: Pick<SpaceType, 'image'> }
  ) };

export type GetNetworkingQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  filters?: Maybe<NetworkingSpaceFilter>;
}>;


export type GetNetworkingQuery = { event: { networkingSpaces: { edges: Array<Maybe<{ node: (
          Pick<NetworkingSpaceType, 'id'>
          & { parent: Pick<SpaceType, 'image' | 'name' | 'slug' | 'published' | 'enableChat' | 'helpContent' | 'helpContentType'> }
        ) }>> } } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateOrganization;
}>;


export type UpdateOrganizationMutation = { updateOrganization: Pick<OrganizationType, 'id'> };

export type AddOrganizationAdminMutationVariables = Exact<{
  data: AddOrganizationAdmin;
}>;


export type AddOrganizationAdminMutation = { addOrganizationAdmin: Pick<UserType, 'about' | 'company' | 'email' | 'firstName' | 'hasLoggedOn' | 'id' | 'jobtitle' | 'lastName' | 'mugshot'> };

export type RemoveOrganizationAdminMutationVariables = Exact<{
  data: RemoveOrganizationAdmin;
}>;


export type RemoveOrganizationAdminMutation = { removeOrganizationAdmin: Pick<UserType, 'id'> };

export type RemoveEventAdminMutationVariables = Exact<{
  data: RemoveAdmin;
}>;


export type RemoveEventAdminMutation = Pick<Mutation, 'removeAdmin'>;

export type OrganizationFragment = (
  Pick<OrganizationType, 'id' | 'externalId' | 'contactPosition' | 'contactPhone' | 'contactName' | 'contactEmail' | 'billingAddressIsPhysicalAddress' | 'membershipActivatedAt' | 'membershipExpiresAt' | 'name' | 'subdomain' | 'vatNumber' | 'billingDepartment' | 'cocNumber' | 'language'>
  & { admins: Array<Pick<UserType, 'firstName' | 'email' | 'id' | 'lastName' | 'hasLoggedOn'>>, billingAddress: Pick<AddressType, 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postalCode' | 'state'>, physicalAddress: Pick<AddressType, 'addressLine1' | 'addressLine2' | 'city' | 'country' | 'postalCode' | 'state'>, images?: Maybe<{ edges: Array<Maybe<{ node: Pick<ImageType, 'id' | 'file'> }>> }> }
);

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationQuery = { organization: OrganizationFragment };

export type GetEventsQueryVariables = Exact<{
  filters?: Maybe<MyEventFilters>;
}>;


export type GetEventsQuery = { myEvents: { edges: Array<Maybe<{ node: (
        Pick<EventType, 'id' | 'createdAt' | 'startDate' | 'endDate' | 'name' | 'slug' | 'description' | 'firstPublishedAt'>
        & { organization?: Maybe<Pick<OrganizationType, 'id'>>, admins: { edges: Array<Maybe<{ node: Pick<UserType, 'firstName' | 'email' | 'id' | 'lastName' | 'hasLoggedOn'> }>> } }
      ) }>> } };

export type CreatePosterMutationVariables = Exact<{
  data: CreatePosterInput;
}>;


export type CreatePosterMutation = { createPoster: Pick<PosterType, 'id'> };

export type UpdatePosterMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdatePosterInput;
}>;


export type UpdatePosterMutation = { updatePoster: Pick<PosterType, 'id' | 'preview' | 'pdf'> };

export type DeletePosterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePosterMutation = Pick<Mutation, 'deletePoster'>;

export type UpdatePosterSpaceMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdatePosterSpaceInput;
}>;


export type UpdatePosterSpaceMutation = { updatePosterSpace: (
    Pick<PosterSpaceType, 'id'>
    & { parent: Pick<SpaceType, 'image'> }
  ) };

export type ImportPosterMutationVariables = Exact<{
  posterSpace: Scalars['ID'];
  data: Array<ImportPoster> | ImportPoster;
}>;


export type ImportPosterMutation = { importPoster: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type GetPosterQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  filters?: Maybe<PosterSpaceFilter>;
}>;


export type GetPosterQuery = { event: { posterSpaces: { edges: Array<Maybe<{ node: (
          Pick<PosterSpaceType, 'id' | 'enableVideo' | 'enableMessaging' | 'posterSorting'>
          & { parent: Pick<SpaceType, 'name' | 'image' | 'helpContent' | 'helpContentType' | 'published' | 'enableChat'> }
        ) }>> } } };

export type PosterItemFragment = (
  Pick<PosterType, 'id' | 'pdf' | 'preview' | 'authorNames' | 'title' | 'abstract' | 'videoUrl' | 'enableChat' | 'locationType'>
  & { author?: Maybe<Pick<UserType, 'email' | 'hasLoggedOn'>> }
);

export type GetPosterListQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  filters?: Maybe<PosterSpaceFilter>;
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
  sort?: Maybe<PosterOrder>;
}>;


export type GetPosterListQuery = { event: { posterSpaces: { edges: Array<Maybe<{ node: (
          Pick<PosterSpaceType, 'id'>
          & { posters?: Maybe<(
            Pick<PosterConnection, 'totalCount'>
            & { edges: Array<Maybe<{ node: PosterItemFragment }>>, pageInfo: Pick<Pagination, 'hasPreviousPage' | 'hasNextPage' | 'endCursor'> }
          )> }
        ) }>> } } };

export type UpdatePresentationSpaceMutationVariables = Exact<{
  data: UpdatePresentationSpaceInput;
  id: Scalars['Int'];
}>;


export type UpdatePresentationSpaceMutation = { updatePresentationSpace: (
    Pick<PresentationSpaceType, 'id'>
    & { parent?: Maybe<Pick<SpaceType, 'image'>> }
  ) };

export type GetPresentationQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  filters?: Maybe<PresentationSpaceFilter>;
}>;


export type GetPresentationQuery = { event: { presentationSpaces: { edges: Array<Maybe<{ node: (
          Pick<PresentationSpaceType, 'id' | 'streamIsContinues' | 'streamUrl' | 'interactionIsContinues' | 'interactionUrl' | 'showAttendees'>
          & { parent?: Maybe<Pick<SpaceType, 'id' | 'slug' | 'enableChat' | 'helpContent' | 'helpContentType' | 'name' | 'image' | 'published'>> }
        ) }>> } } };

export type CreateShowMutationVariables = Exact<{
  input: CreateShow;
}>;


export type CreateShowMutation = { createShow: Pick<ShowType, 'id'> };

export type DeleteShowMutationVariables = Exact<{
  filters: ShowFilter;
}>;


export type DeleteShowMutation = Pick<Mutation, 'deleteShows'>;

export type UpdateShowMutationVariables = Exact<{
  filters: ShowFilter;
  input: UpdateShow;
}>;


export type UpdateShowMutation = { updateShows: Array<Pick<ShowType, 'id' | 'attachment' | 'attachmentName' | 'virtualImage' | 'image'>> };

export type ImportShowsMutationVariables = Exact<{
  event: Scalars['EventID'];
  data: Array<ImportShow> | ImportShow;
}>;


export type ImportShowsMutation = { importShows: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type CreateShowContainerMutationVariables = Exact<{
  event: Scalars['EventID'];
  data: CreateShowContainer;
}>;


export type CreateShowContainerMutation = { createShowContainer: Pick<ShowContainerType, 'id'> };

export type UpdateShowsContainerMutationVariables = Exact<{
  data: UpdateShowContainer;
  id: Scalars['Int'];
}>;


export type UpdateShowsContainerMutation = { updateShowContainer: Pick<ShowContainerType, 'id'> };

export type DeleteShowContainerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteShowContainerMutation = Pick<Mutation, 'deleteShowContainer'>;

export type CreateProgramTagCategoryMutationVariables = Exact<{
  data: CreateTagCategory;
}>;


export type CreateProgramTagCategoryMutation = { createProgramTagCategory: Pick<TagCategoryType, 'id'> };

export type CreateProgramTagMutationVariables = Exact<{
  data: CreateTag;
}>;


export type CreateProgramTagMutation = { createProgramTag: Pick<TagType, 'id'> };

export type UpdateProgramTagMutationVariables = Exact<{
  data: UpdateTag;
  id: Scalars['ID'];
}>;


export type UpdateProgramTagMutation = { updateProgramTag: Pick<TagType, 'id'> };

export type DeleteProgramTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProgramTagMutation = Pick<Mutation, 'deleteProgramTag'>;

export type UpdateProgramTagCategoryMutationVariables = Exact<{
  data: UpdateTagCategory;
  id: Scalars['ID'];
}>;


export type UpdateProgramTagCategoryMutation = { updateProgramTagCategory: Pick<TagCategoryType, 'id'> };

export type DeleteProgramTagCategoryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProgramTagCategoryMutation = Pick<Mutation, 'deleteProgramTagCategory'>;

export type ShowsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
  eventId: Scalars['EventID'];
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<ShowOrder>;
  upcomingOnly?: Maybe<Scalars['Boolean']>;
}>;


export type ShowsQuery = { event: { shows: (
      Pick<ShowItemConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        Pick<ShowItemEdge, 'cursor'>
        & { node: (
          Pick<ShowItem, 'id' | 'isContainer' | 'name' | 'description' | 'startDate' | 'endDate' | 'virtualSpace' | 'mapitem' | 'virtualImage' | 'color'>
          & { sponsor?: Maybe<Pick<SponsorType, 'id' | 'name' | 'logo'>>, items?: Maybe<Array<(
            Pick<ShowItem, 'id' | 'name' | 'startDate' | 'endDate' | 'virtualSpace' | 'mapitem' | 'virtualImage' | 'color'>
            & { sponsor?: Maybe<Pick<SponsorType, 'id' | 'name' | 'logo'>> }
          )>> }
        ) }
      )>>, pageInfo: Pick<Pagination, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'> }
    ) } };

export type GetShowQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetShowQuery = { show: (
    Pick<ShowType, 'id' | 'externalId' | 'name' | 'startDate' | 'endDate' | 'color' | 'description' | 'attachment' | 'attachmentName' | 'streamUrl' | 'embeddedUrl' | 'enableChat' | 'showAttendees' | 'streamIsContinues' | 'virtualImage' | 'image' | 'playbackUrl' | 'releaseDate'>
    & { performers: { edges: Array<Maybe<{ node: Pick<PerformerType, 'id' | 'mugshot' | 'name'> }>> }, virtualSpace?: Maybe<Pick<SpaceType, 'id'>>, mapitem?: Maybe<Pick<EventMapItemType, 'id'>>, moderator?: Maybe<Pick<UserType, 'hasLoggedOn' | 'firstName' | 'email'>>, sponsor?: Maybe<Pick<SponsorType, 'id' | 'name' | 'logo'>>, container?: Maybe<Pick<ShowContainerType, 'id'>>, tags?: Maybe<Array<Pick<TagType, 'id'>>>, onlyForSegments?: Maybe<Array<Pick<SegmentType, 'id'>>> }
  ) };

export type PerformersQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  first: Scalars['Int'];
  filters?: Maybe<PerformerFilter>;
  sort?: Maybe<PerformerOrder>;
}>;


export type PerformersQuery = { event: { performers?: Maybe<{ edges: Array<Maybe<{ node: Pick<PerformerType, 'id' | 'name' | 'mugshot'> }>> }> } };

export type VirtualSpacesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
  first?: Maybe<Scalars['Int']>;
}>;


export type VirtualSpacesQuery = { event: { spaces?: Maybe<{ edges: Array<Maybe<{ node: (
          Pick<SpaceType, 'id' | 'name' | 'enableChat'>
          & { presentationFields?: Maybe<Pick<PresentationSpaceType, 'streamIsContinues' | 'streamUrl' | 'interactionIsContinues' | 'interactionUrl' | 'showAttendees'>> }
        ) }>> }> } };

export type ShowContainersQueryVariables = Exact<{
  eventSlug: Scalars['String'];
}>;


export type ShowContainersQuery = { showContainers: Array<Pick<ShowContainerType, 'id' | 'externalId' | 'startDate' | 'endDate' | 'name' | 'subtitle' | 'description' | 'color' | 'image'>> };

export type ProgramTagsQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type ProgramTagsQuery = { event: { programTags?: Maybe<Array<(
      Pick<TagType, 'id' | 'text' | 'color' | 'order'>
      & { category?: Maybe<Pick<TagCategoryType, 'id' | 'text' | 'order'>> }
    )>> } };

export type ProgramTagCategoriesQueryVariables = Exact<{
  eventId: Scalars['EventID'];
}>;


export type ProgramTagCategoriesQuery = { event: { programTagCategories?: Maybe<Array<Pick<TagCategoryType, 'id' | 'order' | 'text'>>> } };

export type ShowContainerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShowContainerQuery = { showContainer: (
    Pick<ShowContainerType, 'id' | 'externalId' | 'startDate' | 'endDate' | 'name' | 'subtitle' | 'description' | 'color' | 'image' | 'playbackUrl' | 'releaseDate'>
    & { virtualSpace?: Maybe<Pick<SpaceType, 'id'>>, mapitem?: Maybe<Pick<EventMapItemType, 'id'>>, tags?: Maybe<Array<Pick<TagType, 'id'>>>, sponsor?: Maybe<Pick<SponsorType, 'id'>> }
  ) };

export type CreateSpaceMutationVariables = Exact<{
  input: CreateSpace;
}>;


export type CreateSpaceMutation = { createSpace: Pick<SpaceType, 'id' | 'slug'> };

export type UpdateSpaceMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateSpace;
}>;


export type UpdateSpaceMutation = { updateSpace: Pick<SpaceType, 'id'> };

export type DeleteSpaceMutationVariables = Exact<{
  data: DeleteSpace;
}>;


export type DeleteSpaceMutation = Pick<Mutation, 'deleteSpace'>;

export type UpdateHomeSpaceMutationVariables = Exact<{
  eventSlug: Scalars['EventID'];
  data: UpdateEventInput;
}>;


export type UpdateHomeSpaceMutation = { updateEvent: Pick<EventType, 'id'> };

export type GetSpacesOverviewQueryVariables = Exact<{
  eventSlug: Scalars['EventID'];
  type?: Maybe<SpaceTypeEnum>;
  search?: Maybe<Scalars['String']>;
}>;


export type GetSpacesOverviewQuery = { event: { spaces?: Maybe<{ edges: Array<Maybe<{ node: Pick<SpaceType, 'id' | 'slug' | 'name' | 'type' | 'published' | 'timetableOrder'> }>> }> } };

export type CreatePerformerMutationVariables = Exact<{
  event: Scalars['EventID'];
  input: CreatePerformer;
}>;


export type CreatePerformerMutation = { createPerformer: Pick<PerformerType, 'id' | 'name'> };

export type UpdatePerformerMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdatePerformer;
}>;


export type UpdatePerformerMutation = { updatePerformer: Pick<PerformerType, 'id'> };

export type DeletePerformerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePerformerMutation = Pick<Mutation, 'deletePerformer'>;

export type ImportPerformersMutationVariables = Exact<{
  event: Scalars['EventID'];
  data: Array<ImportPerformer> | ImportPerformer;
}>;


export type ImportPerformersMutation = { importPerformers: (
    Pick<ImportResult, 'successCount' | 'errorCount'>
    & { errorItems: Array<Pick<BulkUploadError, 'id' | 'message' | 'hiddenMessage'>> }
  ) };

export type SearchPerformersQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['ID']>;
  eventId: Scalars['EventID'];
  filters?: Maybe<PerformerFilter>;
  sort?: Maybe<PerformerOrder>;
}>;


export type SearchPerformersQuery = { event: { performers?: Maybe<(
      Pick<PerformerConnection, 'totalCount'>
      & { edges: Array<Maybe<{ node: Pick<PerformerType, 'about' | 'attachment' | 'attachmentName' | 'facebook' | 'id' | 'instagram' | 'linkedin' | 'mugshot' | 'name' | 'jobtitle' | 'company' | 'twitter' | 'website' | 'youtube' | 'locationType'> }>>, pageInfo: Pick<Pagination, 'hasPreviousPage' | 'hasNextPage' | 'endCursor'> }
    )> } };
